import { useState, useEffect, useContext, useCallback } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { Editor } from "react-draft-wysiwyg";
import { Loader, Modal, Panel } from 'rsuite';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import Select from 'react-select'
import NavigationPrompt from "react-router-navigation-prompt";
import { IoRecordingOutline, IoCall } from 'react-icons/io5'
import { IoIosShareAlt } from 'react-icons/io'
import { Beforeunload, useBeforeunload } from 'react-beforeunload';
import { getNewMasterListSupplierInfo } from '../../../redux/actions/caller';
import { AiOutlineFileImage } from 'react-icons/ai';
import { FaDownload } from 'react-icons/fa';

import CheckboxComponent from '../../CommonComponents/CheckboxComponent';
import DialerComponent from '../../CommonComponents/DialerComponent';
import InBoundCallComponent from '../../CommonComponents/InboundCallComponent';
import {
    addCardAcceptanceEmails, checkEmployerIdNumberExists, getListSupplierDetailById, removeCardAcceptanceEmails, getCardAcceptanceFee, getCardAcceptanceEmails, getHistoryData,
    getChildSuppliersWithMasterId,
    matchListSupplierToSupplier,
    createChildForListSupplier,
    getMasterSupplierDetailsById,
} from '../../../redux/actions/vendor'
import { toast } from '../../CommonComponents/ToastComponent/toast';
import CreateSupplierComponent from '../../CreateSupplierComponent';
import CreateMasterSupplierComponent from '../../CreateMasterSupplierComponent';
import { getAllListSupplierInfo, addVendorInCallsDetails, addListSupplierHistory, createSupplierBasicInfo, updateSupplierBasicInfo, createSupplierPaymentInfo, updateSupplierPaymentInfo, createSupplierCardInfo, updateSupplierCardInfo, updateVendorInCallsById, approveCallerDetails, updateVendorInCallsDetailsById, rejectCallerDetails, linkCallerDetailsLater, getStatesToNotRecordCalls, createCallRecord, updateCallRecord, addCallDetails, updateCallDetails, shareCall, updateListMasterGlobalAcceptance, getCallRecordings, updateListMasterSupplierDetails, updateListSupplierDetails, addContactNameForCall, linkContactNameForAllCalls, createMasterSupplierBasicInfo, updateMasterSupplierBasicInfo, updateNewMasterSupplierCardInfo, updateNewMasterSupplierPaymentInfo, linkNewMatchedSupplierInfo, getSupplierCallDetailsById } from '../../../redux/actions/caller';
import { capitalizeFirstCharacter, generateAchAcceptanceChangeLog, generateCardAcceptanceChangeLog, generateCheckAcceptanceChangeLog, generateSupplierBasicInfoChangeLog, getReadableTextForChangelog } from '../../../services/helper';
import NotesIcon from '../../../assets/svg/notes-icon.svg'
import LoaderComponent from '../../CommonComponents/LoaderComponent';
import QaNotesModal from '../../QualityComponent/modals/qa-notes-modal';
import AudioTranscript from '../../CommonComponents/AudioTranscript';
import { WebSocketContext } from '../../../hooks/useWebSocket';
import ThreeStateToggleButton from '../../CommonComponents/ThreeStateToggleButton';
import ChildSuppliers from './childSuppliers';
import { getContacts, getExistingContacts } from '../../../redux/actions/contact';
import ModalComponent from '../../CommonComponents/Modal';
import CreateChildVendorFromMaster from '../../AssignVendorComponent/tabs/SupplyComponent/createChildVendorFromMaster';
import AllContacts from '../../ContactsComponent/allContacts';
import CreateContact from '../../ContactsComponent/createContact';
import ContactView from '../../ContactsComponent/contactView';
import { END_INCOMING_CALL } from '../../../redux/actionTypes/caller';
import ComposeEmail from '../../ComposeEmail';
import SupplierHistoricalPayments from '../../AssignVendorComponent/tabs/SupplyComponent/historical-payments';
import EmailHistory from '../../EmailHistory';
import ChangeLogIcon from '../../../assets/svg/changelog-icon.svg';
import { downloadFileFromS3Bucket } from '../../../redux/actions/vendor';
import { AppContext } from '../../../context';
import { getRegisteredEmails } from '../../../redux/actions/emailSettings';
import { createNotification } from '../../../redux/actions/notification';
import { CONSTANTS } from '../../../utils/constants/constants';

const AddCallerDetails = ({ vendorInCallsData = {}, vendorId, vendorInCallsDetailsId, type = 'call', onClose, callsTableData, supplierId = null, activeKey }) => {
    const history = useHistory()
    const unSuccessfullEnablementReasons = ['Voicemail', 'Refused Information', 'Requested Do Not Call', 'Requested Additional Information', 'Unable To Locate Correct Phone Number', 'Business Closed']
    const userSuggestion = []
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        getEmailsForListSupHandler,
        allHistories,
        isLoadingHistories,
        isLoadingEmailHistories,
        setIsLoadingHistories,
        setIsLoadingEmailHistories,
        clearStates,
        parentEmailHistories,
        setParentEmailHistories,
        childEmailHistories,
        setChildEmailHistories,
        unreadEmails,
        sortHistories,
        callerRegisteredEmails,
        setContactsFromAddCallers,
        categorizeEmail,
        setValidUnReadEmails,
        reauthenticateModal,
        setReauthenticateModal,
        emailsToReauthenticate,
        googleTokensValidationHandler,
        googleLogin,
        getSubscriptions,
        getNewUnreadNotification
    } = useContext(AppContext);

    const location = useLocation();
    const { socketIo } = useContext(WebSocketContext)
    const { hash } = useLocation();
    const {
        user: {
            domainUsers,
            users
        },
        auth: { user },
        caller: { twilioDevice, incomingCall },
        domain: { currentDomain }
    } = store

    const { id } = user
    const multiSelectColumns = ['productSpecificOptions', 'emailRemitRequirements', 'phoneRemitRequirements', 'faxRemitRequirements', 'onlineRemitRequirements', 'posRemitRequirements']

    const historyTabs = [
        {
            label: 'All',
            value: 'all',
        },
        {
            label: 'Notes',
            value: 'notes',
        },
        {
            label: 'Files',
            value: 'files',
        },
        {
            label: 'Change Log',
            value: 'changelog',
        },
        {
            label: 'Call Recordings',
            value: 'callRecordings',
        },
        {
            label: 'Email',
            value: 'email',
        }
    ]

    const STOPPED = "Pending QA - Stopped Sequencing"

    domainUsers && domainUsers.map((user) => {
        var text = user?.user?.firstname + (user?.user?.lastname ? ' ' + user?.user?.lastname : '')
        var value = user?.user?.email
        userSuggestion.push({ text: text, value: text, url: 'https://' + value })
    })

    const [isReloadPage, setIsRelaodPage] = useState(false)
    const [unSuccessfullEnablementReason, setUnSuccessfullEnablementReasons] = useState('')
    const [isMarkAsComplete, setIsMarkAsComplete] = useState(false)
    const [hideEditorClass, setHideEditorClass] = useState('hide')
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [isDisabledButtons, setIsDisabledButtons] = useState(false)
    const [showAdvanceSettings, setShowAdvanceSettings] = useState(false)
    const [contactName, setContactName] = useState('')
    const [contactNameId, setContactNameId] = useState(null)
    const [dialedPhoneNumer, setDialedPhoneNumer] = useState(null)
    const [isUpdatingContactName, setIsUpdatingContactName] = useState(false)
    const [supplierInfo, setSupplierInfo] = useState({})
    const [supplierOldInfo, setSupplierOldInfo] = useState({})
    const [supplierPaymentInfo, setSupplierPaymentInfo] = useState({})
    const [supplierOldPaymentInfo, setSupplierOldPaymentInfo] = useState({})
    const [supplierCardInfo, setSupplierCardInfo] = useState({})
    const [supplierOldCardInfo, setSupplierOldCardInfo] = useState({})
    const [supplierACHInfo, setSupplierACHInfo] = useState({})
    const [supplierCheckInfo, setSupplierCheckInfo] = useState({})
    const [callSID, setCallSID] = useState('')
    const [status, setStatus] = useState('');
    const [dialerShowClass, setDialerShowClass] = useState('')
    const [isCallDialed, setIsCallDialed] = useState(false)
    const [isIncomingCall, setIsIncomingCall] = useState(false)
    const [call, setCall] = useState(null)
    const [callStartTime, setCallStartTime] = useState(null);
    const [incomingPhoneNo, setIncomingPhoneNo] = useState(null)
    const [vendorInfo, setVendorInfo] = useState([])
    const [vendorInCallData, setVendorInCallData] = useState({})
    const [vendorInCallsDetails, setVendorInCallsDetails] = useState([])
    const [matchData, setMatchData] = useState([])
    const [callerId, setCallerId] = useState(null)
    const [historyData, setHistoryData] = useState([])
    const [histories, setHistories] = useState([])
    const [isLoadingListSupInfo, setIsLoadingListSupInfo] = useState(false)
    const [isLoadingAllListSupInfo, setIsLoadingAllListSupInfo] = useState(false)
    const [isApprovingOrRejecting, setIsApprovingOrRejecting] = useState(false)
    const [showQaPromt, setShowQaPromt] = useState(false)
    const [statesToNotRecordCalls, setStatesToNotRecordCalls] = useState([])
    const [currentCallData, setCurrentCallData] = useState({})
    const [prevCallId, setPrevCallId] = useState(null)
    const [callDetails, setCallDetails] = useState({})
    const [isRecordCurrentCall, setIsRecordCurrentCall] = useState(false)
    const [callStatus, setCallStatus] = useState({})
    const [callRecordings, setCallRecordings] = useState([])
    const [showShareCall, setShowShareCall] = useState(false)
    const [shareCallId, setShareCallId] = useState(null)
    const [callingScript, setCallingScript] = useState(null)
    const [inboundCallDetails, setInboundCallDetails] = useState([])
    const [isLoading, setIsLoading] = useState({
        basicInfo: false,
        cardInfo: false,
        achInfo: false,
        checkInfo: false,
        globalAcc: false,
        updateVendorInCall: false
    })
    const [supNameForEIN, setSupNameForEIN] = useState({})
    const [supPhoneNumber, setSupPhoneNumber] = useState('')
    const [childSuppliers, setChildSuppliers] = useState([])
    const [contacts, setContacts] = useState([])
    const [showCreateChild, setShowCreateChild] = useState(false)
    const [showAllContacts, setShowAllContacts] = useState(false)
    const [existedContacts, setExistedContacts] = useState([])
    const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
    const [currentContact, setCurrentContact] = useState({})
    const [showAddNewContact, setShowAddNewContact] = useState(false)
    const [contactDataFromField, setContactDataFromField] = useState({})
    const [allContacts, setAllContacts] = useState([])
    const [isRefusedToProvideName, setIsRefusedToProvideName] = useState(null)
    const [matchedSupplierId, setMatchedSupplierId] = useState('')
    const [matchedSupplierDetailInfo, setMatchedSupplierDetailInfo] = useState({})
    const [newMasterSupplierBasicInfo, setnewMasterSupplierBasicInfo] = useState({})
    const [newMatchedSupplierId, setNewMatchedSupplierId] = useState('');
    const [isNewBasicInfo, setIsNewBasicInfo] = useState(false);
    const [allHistoryData, setAllHistoryData] = useState([]);
    const [showStopModal, setShowStopModal] = useState(false)
    const [activeTab, setActiveTab] = useState('notes') //notes, emails
    const [contactOptions, setContactOptions] = useState([])
    const [currentTab, setCurrentTab] = useState('all')
    const [notes, setNotes] = useState([])
    const [changeLog, setChangeLog] = useState([])
    const [files, setFiles] = useState([])
    const [callerAssignedForEmail, setCallerAssignedForEmail] = useState(null)
    const [allUnreadEmailCount, setAllUnreadEmailCount] = useState(0)

    const getNewHistory = async (listSupId) => {
        let matchedSupId = null
        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }

        let supId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : null;

        let allHistory = [...histories]
        const newMasterHistory = await dispatch(getHistoryData(listSupId, null, true)).then((res) => res).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Fetch Data',
            })
        })

        const callRecordings = await dispatch(getCallRecordings(activeKey === 'reenablement' ? listSupId : vendorId, vendorInCallDetailsId, activeKey === 'reenablement' ? vendorId : supId)).then((res) => res).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Fetch Data',
            })
        })
        if (newMasterHistory && newMasterHistory?.length > 0) {
            allHistory = [...newMasterHistory, ...histories, ...callRecordings]
            if (allHistory?.length > 0) {
                allHistory = getUniqueHistoryData(allHistory)
            }
            allHistory = allHistory.sort((first, second) => {
                let firstDate = first.hasOwnProperty('isRecorded') ? first.callStartTime : first.updatedDate
                let secondDate = second.hasOwnProperty('isRecorded') ? second.callStartTime : second.updatedDate
                return secondDate > firstDate ? 1 : -1;
            });
        }

        setAllHistoryData(allHistory)
    }

    const updateTextDescription = async (state) => {
        setHideEditorClass('')
        await setEditorState(state);
    }

    const handleCancelButton = () => {
        setEditorState(EditorState.createEmpty())
        setHideEditorClass('hide')
    }

    const handleNotesSave = async () => {
        let matchedSupId = null
        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }

        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : (supplierInfo.id || null)
        var vendorInCallDetailsId = null

        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }

        const editorContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        const isEmpty = convertToRaw(editorState.getCurrentContent()).blocks.every(block => block.text.trim() === '');

        if (!isEmpty) {
            setIsLoadingListSupInfo(true)
            await addListMasterSupplierHistory(vendorId, vendorInCallDetailsId, {}, {}, 'note', editorContent, false, supplierId)
            setIsLoadingListSupInfo(false)
        } else {
            toast.show({
                title: 'Warning',
                description: 'Please add note!',
            })
        }
    }

    const handleBasicDetailsSave = async (supplierData, contactId = '', contactDataFromField = '', tmpContacts = {}) => {
        let matchedSupId = null
        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }

        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : null

        const basicData = {}
        if (supplierData.employerIdNumber?.value && supplierData.employerIdNumber?.value !== '' && supplierInfo?.employerIdNumber !== supplierData.employerIdNumber?.value) {
            if (supplierData.employerIdNumber?.value !== '' && !/^(\d{2}-\d{7})?$/.test(supplierData.employerIdNumber?.value)) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid Employee Id Number. Must be 9 digit number formatted xx-xxxxxxx.'
                })
                return
            }

            // check that if EIN already exists
            const isEINExists = await dispatch(checkEmployerIdNumberExists({
                employerIdNumber: supplierData.employerIdNumber?.value,
                getEINData: true
            }))
            if (isEINExists?.einResult[0]?.id) {
                setSupNameForEIN(isEINExists?.einResult[0])
            } else {
                setSupNameForEIN({})
            }
            if (isEINExists?.einCount && isEINExists?.einCount > 0) {
                toast.show({
                    title: 'Warning',
                    description: 'Employer Id Number : ' + supplierData.employerIdNumber?.value + ' already exists!'
                })
                return
            }
        }

        Object.keys(supplierData).forEach(key => {
            if (key !== 'id') {
                basicData[key] = supplierData[key].value
            }
        })
        // return
        setIsLoading({ ...isLoading, basicInfo: true })

        var vendorInCallDetailsId = null
        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }

        if (!supplierData?.id) {
            dispatch(createSupplierBasicInfo(basicData, vendorId, vendorInCallDetailsId, supplierCardInfo?.cardInfo?.id, supplierPaymentInfo?.id)).then(async (res) => {
                var note = 'List Supplier Master created by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>';
                supplierId = res?.supplier?.id;
                await addListMasterSupplierHistory(vendorId, vendorInCallDetailsId, supplierOldInfo, res, 'basic', note, false, supplierId)

                if (!supplierCardInfo?.cardInfo?.id) {
                    const cardInfo = {}
                    cardInfo['cardInfo'] = res?.['cardInfo'] || {}
                    cardInfo['cardFeeInfo'] = []
                    cardInfo['cardEmailsInfo'] = []
                    setSupplierCardInfo(cardInfo)
                    setSupplierOldCardInfo(cardInfo)
                }

                if (!supplierPaymentInfo?.id) {
                    setSupplierPaymentInfo(res?.payment)
                    setSupplierOldPaymentInfo({ paymentInfo: res?.payment })
                }
                await getContactsData(res?.supplier?.id)
                setSupplierInfo(res?.supplier)
                setSupplierOldInfo({ baseInfo: res?.supplier })
                toast.show({
                    title: 'Success',
                    description: 'Supplier Basic Info created successfully!',
                })
                setIsLoading({ ...isLoading, basicInfo: false })
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create Supplier Basic Info!',
                })
                setIsLoading({ ...isLoading, basicInfo: false })
            })
        } else {
            if (contactId && contactDataFromField && tmpContacts) {
                const matchedContact = tmpContacts.find(contact => contact.id === contactId);
                if (matchedContact) {
                    if (contactDataFromField === "email") {
                        basicData.emailContactId = matchedContact.id;
                        basicData.email = matchedContact.email || "";
                    } else if (contactDataFromField === "phone") {
                        basicData.phoneContactId = matchedContact.id;
                        basicData.phone = matchedContact.phone || "";
                    }
                }
            }

            dispatch(updateSupplierBasicInfo(basicData, supplierId ? null : vendorId, supplierId ? null : vendorInCallDetailsId, supplierId)).then(async (res) => {
                if (!supplierCardInfo?.cardInfo?.id) {
                    await handleCardAccDataSave()
                }
                if (!supplierPaymentInfo?.id) {
                    await handleACHDataSave()
                }

                await getContactsData(res?.id)
                setSupplierInfo(res)
                supplierId = supplierInfo.id;
                await addListMasterSupplierHistory(vendorId, vendorInCallDetailsId, supplierOldInfo, basicData, 'basic', '', true, supplierId, false, tmpContacts)
                setSupplierOldInfo({ baseInfo: res })
                toast.show({
                    title: 'Success',
                    description: 'Supplier Basic Info updated successfully!',
                })
                setIsLoading({ ...isLoading, basicInfo: false })
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to update Supplier Basic Info!',
                })
                setIsLoading({ ...isLoading, basicInfo: false })
            })
        }
    }

    const handleCardAccDataSave = async (cardInfo = {}, feeData = {}, addedEmailsValues = {}, removeEmailValues = {}) => {
        let matchedSupId = null
        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }
        var matchedSupplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : null
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : (supplierInfo.id || null)

        const cardData = {}
        cardData['supplierId'] = supplierInfo?.id

        Object.keys(cardInfo)?.forEach(key => {
            if (multiSelectColumns.includes(key)) {
                const cardSelectOptions = cardInfo[key]?.map(option => option?.value)?.join(",")
                cardData[key] = cardSelectOptions
            } else if (key === 'cardAuthorizationFormFile' && typeof cardInfo?.[key] === 'string') {
                cardData[key] = cardInfo[key]
            } else {
                cardData[key] = cardInfo[key].value
            }
        })

        var vendorInCallDetailsId = null
        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }

        setIsLoading({ ...isLoading, cardInfo: true })
        if (!supplierCardInfo?.cardInfo?.id) {
            await dispatch(createSupplierCardInfo(cardData, feeData, vendorId, vendorInCallDetailsId)).then(async (res) => {
                const cardInfo = {}
                cardInfo['cardInfo'] = res?.['cardInfo'] || {}
                cardInfo['cardFeeInfo'] = res?.['cardFeeData']
                cardInfo['cardEmailsInfo'] = []
                if (addedEmailsValues && Object.keys(addedEmailsValues).length > 0) {
                    cardInfo['cardEmailsInfo'] = await dispatchEmailsData(addedEmailsValues, null, vendorId, vendorInCallDetailsId)
                }

                await getContactsData(res?.['cardInfo']?.supplierId)
                setSupplierCardInfo(cardInfo)
                toast.show({
                    title: 'Success',
                    description: 'Supplier Card Info created successfully!',
                })
                setIsLoading({ ...isLoading, cardInfo: false })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create Supplier Card Info!',
                })
                setIsLoading({ ...isLoading, cardInfo: false })
            })
        } else {
            dispatch(updateSupplierCardInfo(cardData, feeData, matchedSupplierId ? null : vendorId, supplierCardInfo?.cardInfo?.id, supplierId ? null : vendorInCallDetailsId, supplierId)).then(async (res) => {
                const cardInfo = {}
                cardInfo['cardInfo'] = res?.['cardInfo'] || {}
                cardInfo['cardEmailsInfo'] = supplierCardInfo?.cardEmailsInfo || []
                if (addedEmailsValues && Object.keys(addedEmailsValues)?.length > 0) {
                    cardInfo['cardEmailsInfo'] = await dispatchEmailsData(addedEmailsValues, supplierInfo?.id, vendorId, vendorInCallDetailsId)
                }
                if (removeEmailValues && Object.keys(removeEmailValues)?.length > 0) {
                    cardInfo['cardEmailsInfo'] = await removeCardEmails(removeEmailValues, null, vendorId, vendorInCallDetailsId)
                }

                cardInfo['cardFeeInfo'] = await dispatch(getCardAcceptanceFee(vendorId, vendorInCallDetailsId, true))

                await getContactsData(res?.['cardInfo']?.supplierId)
                setSupplierCardInfo(cardInfo)
                await addListMasterSupplierHistory(vendorId, vendorInCallDetailsId, supplierOldCardInfo, cardData, 'card', '', true, supplierId)
                setSupplierOldCardInfo(cardInfo)
                toast.show({
                    title: 'Success',
                    description: 'Supplier Card Info updated successfully!',
                })
                setIsLoading({ ...isLoading, cardInfo: false })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to update Supplier Card Info!',
                })
                setIsLoading({ ...isLoading, cardInfo: false })
            })
        }
    }
    const handleACHDataSave = async (achInfo = {}, checkInfo = {}, achInstructionFile, supplierPaymentInfo = {}, contactId = '', contactDataFromField = '', tmpContacts = {}) => {
        let matchedSupId = null
        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : (supplierInfo.id || null)

        const achData = {}
        const checkData = {}
        achData['supplierId'] = supplierInfo?.id || null
        Object.keys(achInfo)?.forEach(key => {
            if (key === 'achInstructions' && typeof achInfo?.[key] === 'string') {
                achData[key] = achInfo?.[key]
            } else {
                achData[key] = achInfo?.[key]?.value
            }
        })
        Object.keys(checkInfo)?.forEach(key => {
            checkData[key] = checkInfo?.[key]?.value
        })
        var vendorInCallDetailsId = null
        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }
        setIsLoading({ ...isLoading, achInfo: true })
        if (!supplierPaymentInfo?.id) {
            await dispatch(createSupplierPaymentInfo({ ...checkData, ...achData }, vendorId, vendorInCallDetailsId)).then(async (res) => {
                await getContactsData(achData?.['supplierId'])
                setSupplierACHInfo(achData)
                setSupplierPaymentInfo(res)
                toast.show({
                    title: 'Success',
                    description: 'Supplier ACH Info created successfully!'
                })
                setIsLoading({ ...isLoading, achInfo: false })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create Supplier ACH Info!'
                })
                setIsLoading({ ...isLoading, achInfo: false })
            })
        } else {
            if (contactId && contactDataFromField && tmpContacts) {
                const matchedContact = tmpContacts.find(contact => Number(contact.id) === Number(contactId));
                if (matchedContact) {
                    if (contactDataFromField === "emailAch") {
                        achData.emailContactId = matchedContact.id;
                        achData.emailAch = matchedContact.email || "";
                    } else if (contactDataFromField === "phoneAch") {
                        achData.phoneContactId = matchedContact.id;
                        achData.phoneAch = matchedContact.phone || "";
                    }
                }
            }
            dispatch(updateSupplierPaymentInfo({ ...checkData, ...achData }, supplierPaymentInfo?.id, supplierId ? null : vendorInCallDetailsId, supplierId)).then(async (res) => {
                await getContactsData(achData?.['supplierId'])
                setSupplierACHInfo(achData)
                setSupplierPaymentInfo(res)
                await addListMasterSupplierHistory(vendorId, vendorInCallDetailsId, supplierOldPaymentInfo, achData, 'ach', '', true, supplierId, false, tmpContacts)
                setSupplierOldPaymentInfo({ paymentInfo: res })
                toast.show({
                    title: 'Success',
                    description: 'Supplier ACH Info updated successfully!',
                })
                setIsLoading({ ...isLoading, achInfo: false })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to update Supplier ACH Info!',
                })
                setIsLoading({ ...isLoading, achInfo: false })
            })
        }
    }

    const handleCheckDataSave = (checkInfo, achInfo) => {
        let matchedSupId = null
        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : (supplierInfo.id || null)

        const achData = {}
        const checkData = {}
        checkData['supplierId'] = supplierInfo?.id || null
        Object.keys(achInfo).forEach(key => {
            achData[key] = achInfo?.[key]?.value
        })
        Object.keys(checkInfo).forEach(key => {
            checkData[key] = checkInfo?.[key]?.value
        })

        var vendorInCallDetailsId = null
        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }
        setIsLoading({ ...isLoading, checkInfo: true })
        if (!supplierPaymentInfo?.id) {
            dispatch(createSupplierPaymentInfo({ ...checkData, ...achData }, vendorId, vendorInCallDetailsId)).then(async (res) => {
                await getContactsData(checkData?.['supplierId'])
                setSupplierCheckInfo(checkData)
                setSupplierPaymentInfo(res)
                toast.show({
                    title: 'Success',
                    description: 'Supplier Check Info created successfully!',
                })
                setIsLoading({ ...isLoading, checkInfo: false })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create Supplier Check Info!',
                })
                setIsLoading({ ...isLoading, checkInfo: false })
            })
        } else {
            dispatch(updateSupplierPaymentInfo({ ...checkData, ...achData }, supplierPaymentInfo?.id, supplierId ? null : vendorInCallDetailsId, supplierId)).then(async (res) => {
                await getContactsData(checkData?.['supplierId'])
                setSupplierCheckInfo(checkData)
                setSupplierPaymentInfo(res)
                await addListMasterSupplierHistory(vendorId, vendorInCallDetailsId, supplierOldPaymentInfo, res, 'check', '', true, supplierId)
                setSupplierOldPaymentInfo({ paymentInfo: res })
                toast.show({
                    title: 'Success',
                    description: 'Supplier Check Info updated successfully!',
                })
                setIsLoading({ ...isLoading, checkInfo: false })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to update Supplier Check Info!',
                })
                setIsLoading({ ...isLoading, checkInfo: false })
            })
        }
    }

    const removeCardEmails = async (removeEmailValues, supId, listSupplierId = null, vendorInCallDetailsId = null, hasNewListSupplier = false) => {
        let matchedSupId = null
        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : null

        const emails = await dispatch(
            removeCardAcceptanceEmails({
                supplierId: supId,
                removeEmailsData: {
                    removeEmailValues
                },
                supType: 'listSupplier',
                listSupplierId,
                vendorInCallDetailsId,
                masterId: hasNewListSupplier ? null : supplierId ? supplierId : null
            })
        ).then((cardEmails) => {
            toast.show({
                title: 'Success',
                description: 'Sucessufully removed card acceptance emails!',
            })
            return cardEmails
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to remove card acceptance emails!',
            })
            return []
        })
        return emails
    }

    const handleOnComplete = async (isUpdateVendorInCalls = true) => {
        if (type === 'edit' || type === 'qa') {
            return
        }

        const isNotValidated = checkContactNameValidation()
        if (isNotValidated) {
            return
        }

        if (isUpdateVendorInCalls && vendorInCallData?.id) {
            dispatch(updateVendorInCallsById({
                vendorInCallsData: {
                    ...vendorInCallData,
                    status: 'In Qa'
                },
                vendorInCallsId: vendorInCallData?.id,
                vendorInCallsDetails: {
                    ...vendorInCallsDetails,
                    workingEndTime: new Date()
                }
            }
            )).then(async () => {
                let url = ''
                let host = window.location.host
                let protocol = window.location.protocol
                if (host.includes('localhost')) {
                    url = `http://${host}`
                } else {
                    url = `${protocol}//${host}`
                }

                let changeLogNotes = '';
                if (matchedSupplierId || activeKey === 'reenablement') {
                    let linkToMatchedSupplier = activeKey === 'reenablement' ? `${url}/suppliers/${vendorInfo?.id}` : `${url}/suppliers/${matchedSupplierId}`
                    changeLogNotes = `<b><a href="${linkToMatchedSupplier}">${vendorInfo?.suppliername}</a></b> sent In QA by <b><em>${user?.firstname} ${user?.lastname}</em></b>`;
                } else {
                    changeLogNotes = `<b>${supplierInfo?.suppliername}</b> sent In QA by <b><em>${user?.firstname} ${user?.lastname}</em></b>`;
                }

                if (activeKey === 'reenablement') {
                    changeLogNotes += ' (from reenablement)';
                } else {
                    changeLogNotes += ' (from calls)';
                }
                await dispatch(
                    addListSupplierHistory({
                        listSupplierId: matchedSupplierId || activeKey === 'reenablement' ? newMasterSupplierBasicInfo?.baseInfo?.id : vendorId,
                        note: changeLogNotes,
                        noteType: 'changelog',
                        supplierName: matchedSupplierId || activeKey === 'reenablement' ? newMasterSupplierBasicInfo?.baseInfo?.suppliername : supplierInfo?.suppliername,
                        isInCalls: true,
                        supplierId: matchedSupplierId || activeKey === 'reenablement' ? matchedSupplierId : supplierInfo?.id,
                        createdFrom: activeKey
                    })
                )
                onLinkContactNameForAllCalls()
                onClose(true)
            }).catch(() => {

            })
        } else {
            onLinkContactNameForAllCalls()
            onClose(true)
        }
    }

    const dispatchEmailsData = async (addEmailValues, supId, listSupplierId = null, vendorInCallsDetailsId = null, hasNewListSupplier = false) => {
        let matchedSupId = null

        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : (supplierInfo.id || null)
        const emails = await dispatch(
            addCardAcceptanceEmails({
                supplierId: hasNewListSupplier ? null : supId,
                userId: id,
                cardEmailsData: {
                    addEmailValues
                },
                listSupplierId,
                supType: 'listSupplier',
                vendorInCallsDetailsId,
                masterId: hasNewListSupplier ? null : supplierId ? supplierId : null
            })
        ).then(cardEmails => {
            return cardEmails
        }).catch(() => {
            return []
        })
        return emails
    }

    const addListMasterSupplierHistory = async (vendorId, vendorInCallDetailsId, oldInfo, newInfo, type = 'basic', note = '', isUpdate = true, supplierId = null, isNewInfo = false, allContacts = null) => {
        let tmpContacts = [...contacts]
        if (allContacts && allContacts?.length > 0) {
            tmpContacts = allContacts
        }
        let changeLogNotes = ''
        const tmpMasterSupplierOldDetails = { ...oldInfo }
        const tmpMasterSupplierNewDetails = { ...newInfo }

        if (type === 'note') {
            changeLogNotes = note
        } else {
            if (Object.keys(oldInfo)?.length > 0) {
                if (type === 'basic' && Object.keys(tmpMasterSupplierOldDetails?.baseInfo)?.length > 0) {
                    tmpMasterSupplierOldDetails.baseInfo.phone = /^\d+$/.test(tmpMasterSupplierOldDetails?.baseInfo?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpMasterSupplierOldDetails?.baseInfo?.phone) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierOldDetails?.baseInfo?.phone))?.phone : (tmpMasterSupplierOldDetails?.baseInfo?.phone || '')
                    tmpMasterSupplierOldDetails.baseInfo.email = /^\d+$/.test(tmpMasterSupplierOldDetails?.baseInfo?.email) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierOldDetails?.baseInfo?.email))?.email : (tmpMasterSupplierOldDetails?.baseInfo?.email || '')
                    if (isNewInfo) {
                        tmpMasterSupplierNewDetails.phone = /^\d+$/.test(tmpMasterSupplierNewDetails?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpMasterSupplierNewDetails?.phone) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierNewDetails?.phone))?.phone : (tmpMasterSupplierNewDetails?.phone || '')
                        tmpMasterSupplierNewDetails.email = /^\d+$/.test(tmpMasterSupplierNewDetails?.email) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierNewDetails?.email))?.email : (tmpMasterSupplierNewDetails?.email || '')
                    }
                    changeLogNotes = isUpdate ? note + generateSupplierBasicInfoChangeLog(tmpMasterSupplierOldDetails, tmpMasterSupplierNewDetails) : note;
                } else if (type === 'ach' && Object.keys(tmpMasterSupplierOldDetails?.paymentInfo)?.length > 0) {
                    tmpMasterSupplierOldDetails.paymentInfo.emailAch = /^\d+$/.test(tmpMasterSupplierOldDetails?.paymentInfo?.emailAch) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierOldDetails?.paymentInfo?.emailAch))?.email : (tmpMasterSupplierOldDetails?.paymentInfo?.emailAch || '')
                    if (isNewInfo) {
                        tmpMasterSupplierNewDetails.emailAch = /^\d+$/.test(tmpMasterSupplierNewDetails?.emailAch) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierNewDetails?.emailAch))?.email : (tmpMasterSupplierNewDetails?.emailAch || '')
                    }
                    changeLogNotes = note + generateAchAcceptanceChangeLog(tmpMasterSupplierOldDetails, tmpMasterSupplierNewDetails);
                } else if (type === 'check' && Object.keys(tmpMasterSupplierOldDetails?.paymentInfo)?.length > 0) {
                    changeLogNotes = note + generateCheckAcceptanceChangeLog(oldInfo, tmpMasterSupplierNewDetails);
                } else if (type === 'card' && Object.keys(tmpMasterSupplierOldDetails?.cardInfo)?.length > 0) {
                    tmpMasterSupplierOldDetails.cardInfo.cardPaymentByPhoneValue = /^\d+$/.test(tmpMasterSupplierOldDetails?.cardInfo?.cardPaymentByPhoneValue) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpMasterSupplierOldDetails?.cardInfo?.cardPaymentByPhoneValue) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierOldDetails?.cardInfo?.cardPaymentByPhoneValue))?.phone : (tmpMasterSupplierOldDetails?.cardInfo?.cardPaymentByPhoneValue || '')
                    tmpMasterSupplierOldDetails.cardInfo.cardPaymentIVRPhone = /^\d+$/.test(tmpMasterSupplierOldDetails?.cardInfo?.cardPaymentIVRPhone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpMasterSupplierOldDetails?.cardInfo?.cardPaymentIVRPhone) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierOldDetails?.cardInfo?.cardPaymentIVRPhone))?.phone : (tmpMasterSupplierOldDetails?.cardInfo?.cardPaymentIVRPhone || '')
                    if (isNewInfo) {
                        tmpMasterSupplierNewDetails.cardPaymentByPhoneValue = /^\d+$/.test(tmpMasterSupplierNewDetails?.cardPaymentByPhoneValue) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpMasterSupplierNewDetails?.cardPaymentByPhoneValue) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierNewDetails?.cardPaymentByPhoneValue))?.phone : (tmpMasterSupplierNewDetails?.cardPaymentByPhoneValue || '')
                        tmpMasterSupplierNewDetails.cardPaymentIVRPhone = /^\d+$/.test(tmpMasterSupplierNewDetails?.cardPaymentIVRPhone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpMasterSupplierNewDetails?.cardPaymentIVRPhone) ? tmpContacts?.find(data => data?.id === parseInt(tmpMasterSupplierNewDetails?.cardPaymentIVRPhone))?.phone : (tmpMasterSupplierNewDetails?.cardPaymentIVRPhone || '')
                    }
                    changeLogNotes = generateCardAcceptanceChangeLog(tmpMasterSupplierOldDetails, tmpMasterSupplierNewDetails, {}, {});
                }
            }
        }

        if (changeLogNotes !== '') {
            if (activeKey === 'reenablement') {
                changeLogNotes += ' (from reenablement)';
            } else if (activeKey === 'generalCalls') {
                changeLogNotes += ' (from calls)';
            }
            setIsLoadingAllListSupInfo(true)
            dispatch(
                addListSupplierHistory({
                    listSupplierId: matchedSupplierId || activeKey === 'reenablement' ? newMasterSupplierBasicInfo?.baseInfo?.id : vendorId,
                    note: changeLogNotes,
                    noteType: type === 'note' ? 'note' : 'changelog',
                    vendorInCallsDetailsId: vendorInCallDetailsId,
                    supplierName: vendorInfo?.suppliername,
                    isInCalls: true,
                    supplierId,
                    createdFrom: activeKey
                })
            ).then(async () => {
                const allHistoryData = await dispatch(getHistoryData(vendorId, vendorInCallDetailsId, true))
                if (type === 'note') {
                    setEditorState(EditorState.createEmpty())
                    setHideEditorClass('hide')
                }
                var historydata = [...historyData, ...allHistoryData]
                historydata = historydata.sort((first, second) => {
                    let firstDate = first?.hasOwnProperty('isRecorded') ? first?.callStartTime : first?.updatedDate
                    let secondDate = second?.hasOwnProperty('isRecorded') ? second?.callStartTime : second?.updatedDate
                    return secondDate > firstDate ? 1 : -1;
                });
                historydata = [...new Map(historydata.map(item =>
                    [item['id'], item])).values()];
                setHistoryData(historydata)
                setIsLoadingListSupInfo(false)
                setIsLoadingAllListSupInfo(false)
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to add notes!',
                })
                setIsLoadingListSupInfo(false)
                setIsLoadingAllListSupInfo(false)
            })
        } else {
            setIsLoadingListSupInfo(false)
            setIsLoadingAllListSupInfo(false)
        }
    }

    useEffect(async () => {
        dispatch(getStatesToNotRecordCalls()).then(states => {
            setStatesToNotRecordCalls(states)
        }).catch(() => {
            setStatesToNotRecordCalls([])
        })
        console.log("socketIo", socketIo)
        if (socketIo) {
            socketIo.on("callStatus", (callStatus) => {
                const statusUpdate = JSON?.parse(callStatus);
                setCallStatus(statusUpdate)
            });

            socketIo.on("gettingCallRecordings", (data) => {
                setIsLoadingAllListSupInfo(true)
            });

            socketIo.on("callRecordingUpdate", (callrecordings) => {
                const updatedRecordings = JSON?.parse(callrecordings);
                setCallRecordings(updatedRecordings)
            });

            socketIo.on("addedCallDetails", (callDetails) => {
                const callDetailsData = JSON?.parse(callDetails);
                setInboundCallDetails(callDetailsData)
            });

            socketIo.on("getCallRecordings", async (data) => {
                const parsedData = JSON?.parse(data);
                if (parsedData.listSupplierId || parsedData?.vendorsInCallsDetailId) {
                    const callRecordings = await dispatch(getCallRecordings(parsedData?.listSupplierId, parsedData?.vendorsInCallsDetailId))
                    setCallRecordings(callRecordings)
                }
            });
        }
    }, [])

    useEffect(() => {
        if (callStatus) {
            const { CallStatus } = callStatus
            let outgoingCallHangupButton = document.getElementById('cut-call')
            let incomingCallEndButton = document.getElementById('end-call')
            switch (CallStatus) {
                case 'initiated':
                    if (outgoingCallHangupButton && !callStatus?.CalledVia) {
                        handleCreateCallRecord(callStatus)
                    }
                    break;
                case 'ringing':
                    console.log('Ringing', '\n\n')
                    break;
                case 'in-progress':
                    setCallStartTime(Date.now());
                    setStatus('In-Progress');
                    if (incomingCall || isIncomingCall) {
                        const isState = statesToNotRecordCalls?.find(state => state?.stateCode === callStatus?.FromState)
                        setIsRecordCurrentCall(isState ? false : true)
                    } else {
                        if (outgoingCallHangupButton) {
                            handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration, 'answered')
                        }
                    }
                    break;
                case 'answered':
                    setStatus('answered');
                    break;
                case 'completed':
                    setCallStartTime(null);
                    setStatus('');
                    if (incomingCall || isIncomingCall) {
                        handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid, 'inbound')
                        setIsIncomingCall(false)
                        dispatch({
                            type: END_INCOMING_CALL
                        })
                    } else {
                        if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                            if (call) {
                                outgoingCallHangupButton.click()
                            }
                            handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration)
                            handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid)
                        }
                    }
                    break;
                case 'busy':
                    setCallStartTime(null)
                    if (incomingCall || isIncomingCall) {
                        setIsIncomingCall(false)
                        dispatch({
                            type: END_INCOMING_CALL
                        })
                    } else {
                        if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                            if (call) {
                                outgoingCallHangupButton.click()
                            }
                            handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration, 'rejected')
                            handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid)
                        }
                    }
                    setStatus('');
                    break;
                case 'failed':
                    setStatus('');
                    setCallStartTime(null)
                    if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                        if (call) {
                            outgoingCallHangupButton.click()
                        }
                        handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration, 'failed')
                        handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid)
                    }
                    break;
                case 'no-answer':
                    setStatus('');
                    setCallStartTime(null)
                    console.log('status no-answer')

                    if (incomingCall || isIncomingCall) {
                        setIsIncomingCall(false)
                        dispatch({
                            type: END_INCOMING_CALL
                        })
                    } else {
                        if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                            if (call) {
                                outgoingCallHangupButton.click()
                            }
                            handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration, 'no-answer')
                            handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid)
                        }
                    }
                    break;
                case 'canceled':
                    setStatus('');
                    setCallStartTime(null)
                    if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                        if (call) {
                            outgoingCallHangupButton.click()
                        }
                    }
                    break;
                default:
                    break;
            }
        }
    }, [callStatus])

    useEffect(() => {
        if (callRecordings?.length) {
            setIsLoadingAllListSupInfo(true)
            var historydata = [...historyData, ...callRecordings]
            historydata = historydata.sort((first, second) => {
                let firstDate = first.hasOwnProperty('isRecorded') ? first.callStartTime : first.updatedDate
                let secondDate = second.hasOwnProperty('isRecorded') ? second.callStartTime : second.updatedDate
                return secondDate > firstDate ? 1 : -1;
            });
            historydata = [...new Map(historydata.map(item =>
                [item['id'], item])).values()];
            setHistoryData(historydata)
            setIsLoadingListSupInfo(false)
            setIsLoadingAllListSupInfo(false)
        } else {
            setHistoryData(historyData)
            setIsLoadingListSupInfo(false)
        }
    }, [callRecordings])

    useEffect(() => {
        if (Object.keys(inboundCallDetails)?.length) {
            dispatch(createCallRecord({
                callerAssigned: vendorInCallData?.callerAssigned,
                listSupplierId: vendorInCallData?.listSupplierId,
                vendorInCallsId: vendorInCallData?.id,
                callType: 'inbound',
                callStartTime: inboundCallDetails?.startTime,
                dateCalled: inboundCallDetails?.startTime,
                callSid: inboundCallDetails?.callSid,
                vendorsInCallsDetailId: vendorInCallsDetails?.id || null,
                isRecorded: isRecordCurrentCall
            })).then(calldata => {
                setCurrentCallData(calldata)
                setPrevCallId(calldata?.id)
            }).catch(() => {
                setCurrentCallData({})
                setPrevCallId(null)
            })
        }
    }, [inboundCallDetails])

    // REJECT INCOMING CALL
    function rejectIncomingCall(call) {
        setIsIncomingCall(false)
        setCall(null)
        updateCallsAttempted()
    }

    // HANG UP INCOMING CALL
    function hangupIncomingCall(call) {
        setIsIncomingCall(false)
        setCall(null)
        updateCallsAttempted()
    }

    const makeOutgoingCall = async (phoneNumber) => {
        const AreaCodes = require('areacode-city-states');
        let areaCodes = new AreaCodes();
        let stateCode = ''

        await areaCodes.get(phoneNumber, function (err, data) {
            stateCode = data?.stateCode
        });
        const isState = statesToNotRecordCalls?.find(state => state?.stateCode === stateCode)
        setIsRecordCurrentCall(isState ? false : true)
        setStatus('Calling...');
        let outgoingCallHangupButton = document.getElementById('cut-call')
        try {
            const outboundCall = await twilioDevice.connect({
                To: phoneNumber,
                isRecord: isState ? false : true,
                userId: user?.id
            });
            setDialedPhoneNumer(phoneNumber)

            if (vendorInCallData?.id) {
                dispatch(updateVendorInCallsById({
                    vendorInCallsData: {
                        ...vendorInCallData,
                        lastCalledDate: new Date()
                    },
                    vendorInCallsId: vendorInCallData?.id
                })).then((res) => {
                    setVendorInCallData(res)
                }).catch(() => {

                })
            }

            setCall(outboundCall)
            setIsCallDialed(true)
            outboundCall.on('ringing', () => {
                setStatus('Ringing');
            });

            outboundCall.on("accept", (connection) => {
                setCallSID(connection?.parameters?.CallSid)
                setStatus('Ringing');
            });

            outboundCall.on('error', (error) => {
                setStatus('Error');
                outgoingCallHangupButton.click()
            });
        } catch (error) {
            setStatus('Error');
            outgoingCallHangupButton.click()
        }
    };

    const handleCallEndClick = () => {
        setCallStartTime(null)
        setIsCallDialed(false)
        setDialerShowClass('')
        setCall(null)
        updateCallsAttempted()
    }

    const handleShareCallClick = (e) => {
        e.stopPropagation();
        setShowShareCall(true)
        setShareCallId(e?.currentTarget?.id)
    }

    const panelHeader = (date = '', userId = null, isRecording = false, callType = '', callerId = null, isCallRecorded = false, callSid, phoneNo, emailHistory, val = null) => {
        let callerName = ''
        const userData = userId ? users?.find((user) => user?.id === userId) : null
        const userName = userData ? userData?.firstname + (userData?.lastname ? ' ' + userData?.lastname : '') : ''
        const dateObject = new Date(date)
        const month = dateObject.toLocaleString('default', { month: 'short' });
        const day = (dateObject.getDate() < 10) ? '0' + dateObject.getDate() : dateObject.getDate();
        const year = dateObject.getFullYear();
        const time = dateObject.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        const fullTime = month + ' ' + day + ',' + ' ' + year + ' ' + time;
        if (callerId) {
            const callerData = users?.find((user) => user?.id === callerId)
            callerName = callerData?.firstname + (callerData?.lastname ? ' ' + callerData?.lastname : '')
        }
        // if (emailHistory?.messageId) {
        //     return <p className='text-white'>{emailHistory?.subject}</p>
        // }

        if (emailHistory?.messageId) {
            return (
                <div style={{ minHeight: '1.5rem' }} className="">Email History</div>
            );
        }

        else {
            return (
                <div className='d-flex align-items-center'>
                    <p className='mb-0'> {isRecording ? `${capitalizeFirstCharacter(callType)} call ${callType === 'outbound' ? 'by' : 'to'} ${callerName} at ` : ''} {fullTime} {phoneNo && <span className='text-black fw-normal'> - {phoneNo}</span>} {userName !== '' && <span> - {userName} </span>} {(val?.supplierId || val?.listSupplierId) && val?.isInCalls ? <IoCall style={{ color: 'green', fontSize: '1.5rem' }} /> : <></>} </p>
                    {(isRecording && isCallRecorded) && <div id={`${callSid}`} className='d-flex align-items-center gap-2 ms-auto me-5' onClick={(e) => { handleShareCallClick(e) }}> <IoIosShareAlt color='#65b3e9' size={26} /><h4 className='fw-bold text-black mb-0'>Share call</h4></div>}
                </div>

            )
        }

    }

    const onSubmitClick = async () => {
        let matchedSupId = null

        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : (supplierInfo.id || null)
        if (!unSuccessfullEnablementReason || !unSuccessfullEnablementReason?.value) {
            toast.show({
                title: 'Warning',
                description: 'Please select Unsuccessful Enablement Reason!',
            })
            return
        }

        if (unSuccessfullEnablementReason?.value?.toLowerCase() !== 'voicemail') {
            const isNotValidated = checkContactNameValidation()
            if (isNotValidated) {
                return
            }
        }

        let note = '<b><em>' + user.firstname + ' ' + user.lastname + '</em></b> added Unsuccessful Enablement Reason as <b>' + unSuccessfullEnablementReason?.value + '</b>'
        if (isMarkAsComplete) {
            const completeBtn = document.getElementById('complete-supplier-info-btn')
            vendorInCallData['status'] = "In Qa"
            vendorInCallsDetails['workingEndTime'] = new Date()
            note += ' and marked as Complete.'
            if (completeBtn) {
                await completeBtn.click()
            }
        }

        if (vendorInCallData?.id) {
            setIsLoadingListSupInfo(true)
            dispatch(updateVendorInCallsById({
                vendorInCallsData: {
                    ...vendorInCallData
                },
                vendorInCallsId: vendorInCallData?.id,
                vendorInCallsDetails: {
                    ...vendorInCallsDetails,
                    unsuccessfulEnablementReason: unSuccessfullEnablementReason?.value || '',
                    workingEndTime: new Date()
                }
            }
            )).then(async () => {
                var vendorInCallDetailsId = null
                if (type === 'edit') {
                    vendorInCallDetailsId = vendorInCallsDetailsId
                } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
                    vendorInCallDetailsId = vendorInCallsDetails?.id
                }
                await dispatch(
                    addListSupplierHistory({
                        listSupplierId: vendorId,
                        note: note,
                        noteType: 'changelog',
                        vendorInCallsDetailsId: vendorInCallDetailsId,
                        supplierName: vendorInfo?.suppliername,
                        isInCalls: true,
                        supplierId: supplierId
                    })
                )
                await onLinkContactNameForAllCalls()
                setIsLoadingListSupInfo(false)
                onClose(true)
            }).catch(() => {
                setIsLoadingListSupInfo(false)
            })
        }
    }

    const updateCallsAttempted = () => {
        var vendorInCallDetailsId = null
        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }

        if (vendorInCallData?.id) {
            dispatch(updateVendorInCallsById({
                vendorInCallsData: {
                    ...vendorInCallData,
                    callsAttempted: vendorInCallData?.callsAttempted + 1
                },
                vendorInCallsId: vendorInCallData?.id
            })).then((res) => {
                setVendorInCallData(res)
            }).catch(() => {
            })
        }
    }

    const handleApproveClick = () => {
        var isUpdateAccDate = null
        const cardNotesArray = ['accepts amex', 'accepts mastercard', 'accepts visa', 'amex minimum payment', 'amex maximum payment', 'amex percent fee', 'amex dollar fee', 'amex processing fee type', 'amex processing fee', 'amex minimum payment fee type', 'amex minimum payment fee', 'amex maximum payment fee type', 'amex maximum payment fee', 'amex incremental fee type', 'amex incremental fee', 'amex incremental payment amount', 'visa minimum payment', 'visa maximum payment', 'visa percent fee', 'visa dollar fee', 'visa processing fee type', 'visa processing fee', 'visa minimum payment fee type', 'visa minimum payment fee', 'visa maximum payment fee type', 'visa maximum payment fee', 'visa incremental fee type', 'visa incremental fee', 'visa incremental payment amount', 'mastercard minimum payment', 'mastercard maximum payment', 'mastercard percent fee', 'mastercard dollar fee', 'mastercard processing fee type', 'mastercard processing fee', 'mastercard minimum payment fee type', 'mastercard minimum payment fee', 'mastercard maximum payment fee type', 'mastercard maximum payment fee', 'mastercard incremental fee type', 'mastercard incremental fee', 'mastercard incremental payment amount', 'accepts discount by card payment', 'accepts card payment terms', 'card payment terms value', 'card discount type', 'card discount value', 'token configuration', 'card authorization form file', 'accepts card autorization form', 'accepts receive payment by', 'portal url', 'third party portal url', 'card payment fax', 'card acceptance email added', 'card acceptance emails added', 'card acceptance email removed', 'card acceptance emails removed', 'accepts product specific', 'product specific options', 'email requirements', 'phone requirements', 'fax requirements', 'online requirements', 'pos requirements'] //'card payment phone',

        function includesAnyNote(history) {
            return cardNotesArray.some(note => history?.toLowerCase()?.includes(note))
        }

        if (!supplierInfo?.id) {
            toast.show({
                title: 'Warning',
                description: 'Please create master supplier first!'
            })
            return
        }
        var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
        var note = `<p><b><em> Approved By ${userName} </em></b></p>`
        setIsApprovingOrRejecting(true)
        const listSupplierId = vendorInfo?.id

        const isUERSet = vendorInfo?.vendorsInCallsDetails?.filter(data => data?.unsuccessfulEnablementReason) // To check that Unsuccessful Enablement Reason added by caller or not
        const isCardInfoUpdated = histories?.filter(history => history?.isInCalls === true && includesAnyNote(history?.note))

        if (isUERSet && isUERSet?.length && isCardInfoUpdated?.length === 0) { // not to update acceptance date if Unsuccessful Enablement Reason added and any no card info updated
            isUpdateAccDate = false
        } else if (isCardInfoUpdated && isCardInfoUpdated?.length > 0) { // update acceptance date if no Unsuccessful Enablement Reason added and any card info updated
            isUpdateAccDate = true
        }
        if (matchedSupplierId || activeKey === 'reenablement') {
            dispatch(linkNewMatchedSupplierInfo(matchedSupplierId, isUpdateAccDate))
                .then(() => {
                    let url = ''
                    let host = window.location.host
                    let protocol = window.location.protocol
                    if (host.includes('localhost')) {
                        url = `http://${host}`
                    } else {
                        url = `${protocol}//${host}`
                    }

                    let linkToMatchedSupplier = activeKey === 'reenablement' ? `${url}/suppliers/${vendorInfo?.id}` : `${url}/suppliers/${matchedSupplierId}`
                    let changeLogNotes = `<b><a href="${linkToMatchedSupplier}">${vendorInfo?.suppliername}</a></b> approved from QA by <b><em>${user?.firstname} ${user?.lastname}</em></b>`;
                    if (activeKey === 'reenablement') {
                        changeLogNotes += ' (from reenablement)';
                    } else {
                        changeLogNotes += ' (from calls)';
                    }
                    dispatch(
                        addListSupplierHistory({
                            listSupplierId: newMasterSupplierBasicInfo?.baseInfo?.id,
                            note: changeLogNotes,
                            noteType: 'changelog',
                            supplierName: newMasterSupplierBasicInfo?.baseInfo?.suppliername,
                            isInCalls: false,
                            supplierId: matchedSupplierId,
                            createdFrom: activeKey
                        })
                    )

                    setIsApprovingOrRejecting(false)
                    onClose(true)
                    toast.show({
                        title: 'Success',
                        description: 'Supplier approved successfully!',
                    })
                }).catch((err) => {
                    toast.show({
                        title: 'Error',
                        description: 'Supplier unable to approve',
                    })
                })
        }
        if (activeKey !== 'reenablement') {
            dispatch(approveCallerDetails({
                listSupplierData: vendorInfo,
                masterId: supplierInfo?.id,
                listId: vendorInfo?.listId,
                listSupplierId: vendorInfo?.id,
                note,
                matchedSupplierId: vendorInfo?.matchedSupplierId ? vendorInfo?.matchedSupplierId : null
            })).then(async (result) => {
                await dispatch(updateListMasterSupplierDetails({
                    masterId: supplierInfo?.id,
                    listSupplierId: listSupplierId,
                    note,
                    updateQaStatus: result?.matchedMastersCount > 1 ? false : true,
                    isUpdateAccDate
                }))
                await dispatch(updateListSupplierDetails({
                    supplierId: result?.supplierid,
                    listSupplierId: listSupplierId,
                    masterId: supplierInfo?.id
                }))
                setIsApprovingOrRejecting(false)
                onClose(true)
                toast.show({
                    title: 'Success',
                    description: 'Caller details approved successfully!',
                })
            }).catch(() => {
                setIsApprovingOrRejecting(false)
                toast.show({
                    title: 'Warning',
                    description: 'Failed to approve caller details!',
                })
            })
        }
    }

    const handleRejectClick = async () => {
        if (vendorInfo?.isStoppedSequencing) {
            setShowStopModal(true)
        } else {
            setShowQaPromt(true)
        }
    }

    const handleSubmitQA = async (qaNotes, ids = null, type = '', supType = '', supplierParams = null) => {
        debugger
        let url = ''
        let host = window.location.host
        let protocol = window.location.protocol
        if (host.includes('localhost')) {
            url = `http://${host}`
        } else {
            url = `${protocol}//${host}`
        }
        var supplierLink = url + `/lists/insequence/addcallerdetails/${vendorInfo?.id}`
        var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
        var editorContent = qaNotes ? draftToHtml(convertToRaw(qaNotes.getCurrentContent())) : '';
        const href = `<a target="_blank" href=${supplierLink}>${vendorInfo.suppliername || 'Unknown'}</a>`
        editorContent = `<p><b><em>List Supplier: ${href} rejected By ${userName} </em></b></p>` + editorContent;
        const callerData = users?.find((user) => user?.id === vendorInCallData?.callerAssigned)
        const emailTo = callerData?.email
        const callerName = callerData?.firstname + (callerData?.lastname ? ' ' + callerData?.lastname : '')
        setIsApprovingOrRejecting(true)
        dispatch(rejectCallerDetails({
            vendorInCallsData: {
                ...vendorInCallData,
                status: vendorInfo?.isStoppedSequencing ? CONSTANTS.STATUS.REJECTED_STOPPED_SEQUENCING : CONSTANTS.STATUS.IN_CALLS
            },
            vendorInCallsId: vendorInCallData?.id,
            listSupplierId: activeKey === 'reenablement' || matchedSupplierId ? newMasterSupplierBasicInfo?.baseInfo?.id : vendorInfo?.id,
            note: editorContent,
            emailTo,
            callerName,
            isStopSequencing: vendorInfo?.isStoppedSequencing || false,
            supplierId: supplierInfo?.id || null,
            isForMatchedListSupplier: matchedSupplierId ? true : false
        })).then(() => {
            setIsApprovingOrRejecting(false)
            onClose(true)
            toast.show({
                title: 'Success',
                description: 'Caller details rejected successfully!',
            })
        }).catch(() => {
            setIsApprovingOrRejecting(false)
            toast.show({
                title: 'Warning',
                description: 'Failed to reject caller details!',
            })
        })

        let tmpObj = {
            type: 'rejected',
            domain: null,
            emailChainId: null,
            emailFrom: null,
            emailTo: null,
            bodyPreview: null,
            supplierId: null,
            phone: null,
            isRead: false,
            listSupplierId: vendorId,
            qaRejectionNotes: editorContent,
            subject: null,
            callerAssigned: vendorInCallData?.callerAssigned
        }

        let createResult = await dispatch(createNotification(tmpObj)).then(res => res).catch(err => {
            if (err) {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Create Notification',
                })
            }
        })

        if (createResult?.message === CONSTANTS.API_RES_MESSAGE.CREATED_SUCCESS) {
            getNewUnreadNotification()
        }
    }

    const handleOnOk = async (event = null) => {
        const isNotValidated = checkContactNameValidation()
        if (isNotValidated) {
            return
        }
        if (vendorInCallsDetails?.id) {
            setIsLoading({ ...isLoading, updateVendorInCall: true })
            dispatch(updateVendorInCallsDetailsById({
                vendorInCallsDetailsId: vendorInCallsDetails?.id,
                vendorInCallsDetails: {
                    ...vendorInCallsDetails,
                    workingEndTime: new Date()
                }
            })).then((callsData) => {
                setVendorInCallsDetails(callsData)
                setIsLoading({ ...isLoading, updateVendorInCall: false })
            }).catch(() => {
                setIsLoading({ ...isLoading, updateVendorInCall: false })
            })

            onLinkContactNameForAllCalls()
        }

        if (event) {
            event()
        }
        if (call) {
            call.disconnect();
        }
        if (!incomingCall) {
            onClose(true)
        }
    }

    const handleCreateCallRecord = async (statusUpdate, callType = 'outbound') => {
        let matchedSupId = null

        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : (supplierInfo.id || null)
        const callStartTime = new Date()
        if (!incomingCall) {
            await dispatch(addCallDetails({
                userId: user?.id,
                callerAssigned: user?.id,
                internalNumber: statusUpdate?.From,
                externalNumber: statusUpdate?.To,
                startTime: callStartTime,
                callType: 'outbound',
                callSid: statusUpdate?.ParentCallSid,
                externalNumberCity: statusUpdate?.ToCity,
                externalNumberState: statusUpdate?.ToState,
                externalNumberZip: statusUpdate?.ToZip,
                isRecorded: isRecordCurrentCall
            })).then(calldata => {
                setCallDetails(calldata)
            }).catch((err) => {
                setCallDetails({})
            })
        }
        dispatch(createCallRecord({
            callerAssigned: (callType === 'outbound' && vendorId) ? (vendorInCallsData?.callerAssigned || vendorInCallData?.callerAssigned) : vendorInCallData?.callerAssigned,
            listSupplierId: matchedSupplierId ? matchedSupplierDetailInfo?.id : (callType === 'outbound' && vendorId) ? (vendorInCallsData?.listSupplierId || vendorInCallData?.listSupplierId) : vendorInCallData?.listSupplierId,
            vendorInCallsId: (callType === 'outbound' && vendorId) ? (vendorInCallsData?.id || vendorInCallData?.id) : vendorInCallData?.id,
            callType: callType,
            callStartTime: callStartTime,
            dateCalled: callStartTime,
            callSid: statusUpdate?.ParentCallSid,
            vendorsInCallsDetailId: vendorInCallsDetails?.id || null,
            supplierId: supplierId,
            isRecorded: isRecordCurrentCall
        })).then(calldata => {
            setCurrentCallData(calldata)
            setPrevCallId(calldata?.id)
        }).catch(() => {
            setCurrentCallData({})
            setPrevCallId(null)
        })
    }

    const handleUpdateCallRecord = (duration, callSid, callType = 'outbound') => {
        const tmpCallData = {
            ...currentCallData,
            callEndTime: new Date(),
            callDuration: duration,
            callSid: callSid,
            vendorsInCallsDetailId: vendorInCallsDetails?.id,
            isRecorded: isRecordCurrentCall
        }
        if (callType === 'inbound') {
            tmpCallData.vendorInCallsId = vendorInCallData?.id //vendorInCallsDetails?.vendorsInCallId
        }

        if (currentCallData?.id) {
            dispatch(updateCallRecord(tmpCallData, currentCallData?.id)).then(() => {
                setCurrentCallData({})
                setIsRecordCurrentCall(false)
            }).catch(() => {
                setCurrentCallData({})
                setIsRecordCurrentCall(false)
            })
        }

        if (callType === 'inbound' && location?.state && location?.state?.IsIncomingCall && matchData?.length) {
            if (vendorInCallsDetails?.id) {
                dispatch(updateVendorInCallsDetailsById({
                    vendorInCallsDetailsId: vendorInCallsDetails?.id,
                    vendorInCallsDetails: {
                        ...vendorInCallsDetails,
                        callerAssigned: vendorInCallData?.callerAssigned,
                        listSupplierId: vendorInCallData?.listSupplierId,
                        vendorsInCallId: vendorInCallData?.id
                    }
                })).then((callsData) => {
                    setVendorInCallsDetails(callsData)
                }).catch(() => {

                })
            }
        }
    }

    const handleUpdateCallDetails = (callSid, duration, status) => {
        let tmpCallDetails = { ...callDetails, isRecorded: isRecordCurrentCall }
        if (status) {
            tmpCallDetails.callStatus = status
        }
        if (status !== 'answered') {
            tmpCallDetails.callDuration = duration
            tmpCallDetails.endTime = new Date()
        }
        dispatch(updateCallDetails(tmpCallDetails, callSid)).then(calldata => {
            setCallDetails({})
        }).catch((err) => {
            setCallDetails({})
        })
    }

    const handleShareCallSubmit = (notes) => {
        var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
        var editorContent = notes ? draftToHtml(convertToRaw(notes.getCurrentContent())) : '';
        var regex = /<a .*?>/g
        const emailsArray = [...editorContent.matchAll(regex)]
        var emails = []
        emailsArray && emailsArray.map((item) => {
            var hrefRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g
            var valueRegex = /<a\s+(?:[^>]*?\s+)?data-value="([^"]*)"/g
            const hrefArray = [...item[0].matchAll(hrefRegex)]
            const valueArray = [...item[0].matchAll(valueRegex)]
            if (hrefArray.length && valueArray.length) {
                const href = hrefArray?.[0]?.[1]
                const value = valueArray?.[0]?.[1]
                emails.push({ email: href.replaceAll('https://', ''), name: value.replaceAll('https://', '') })
            }
        })
        if (!emails || emails?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'Please add user email to share the call!',
            })
            return
        }
        dispatch(shareCall(
            editorContent,
            userName,
            emails,
            shareCallId,
            vendorId
        )).then(() => {
            setShowShareCall(false)
            setShareCallId(null)
        }).catch(() => {
        })
    }

    const handleGlobalAcceptanceSave = (isGlobalAcceptance) => {
        var vendorInCallDetailsId = null
        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }
        setIsLoading({ ...isLoading, globalAcc: true })
        dispatch(updateListMasterGlobalAcceptance(
            isGlobalAcceptance,
            supplierCardInfo?.cardInfo?.id,
            vendorId,
            vendorInCallDetailsId
        )).then(async (res) => {
            let changeLogNotes = ''
            var oldReadableText = getReadableTextForChangelog(supplierCardInfo?.cardInfo?.id ? supplierCardInfo?.cardInfo?.isAcceptGlobalAcceptance : null)
            var newReadableText = getReadableTextForChangelog(isGlobalAcceptance)
            changeLogNotes += 'Global Acceptance updated from ' + oldReadableText + ' to ' + newReadableText;
            if (changeLogNotes !== '') {
                await dispatch(
                    addListSupplierHistory({
                        listSupplierId: vendorId,
                        note: changeLogNotes,
                        noteType: 'changelog',
                        vendorInCallsDetailsId: vendorInCallDetailsId,
                        supplierName: vendorInfo?.suppliername || '',
                        isInCalls: true
                    })
                ).then(async (history) => {
                    const allHistoryData = await dispatch(getHistoryData(vendorId, vendorInCallDetailsId, true))
                    var historydata = [...historyData, ...allHistoryData]
                    historydata = historydata.sort((first, second) => {
                        let firstDate = first.hasOwnProperty('isRecorded') ? first.callStartTime : first.updatedDate
                        let secondDate = second.hasOwnProperty('isRecorded') ? second.callStartTime : second.updatedDate
                        return secondDate > firstDate ? 1 : -1;
                    });
                    historydata = [...new Map(historydata.map(item =>
                        [item['id'], item])).values()];
                    setHistoryData(historydata)
                }).catch(() => {
                    toast.show({
                        title: 'Warning',
                        description: 'Failed to add changelog!',
                    })
                })
            }

            const cardInfo = { ...supplierCardInfo }
            cardInfo['cardInfo'] = res?.['cardInfo'] || {}

            setSupplierCardInfo(cardInfo)
            toast.show({
                title: 'Success',
                description: res?.message
            })

            setShowAdvanceSettings(false)
            setIsLoading({ ...isLoading, globalAcc: false })
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to update Global Acceptance!'
            })
            setShowAdvanceSettings(false)
            setIsLoading({ ...isLoading, globalAcc: false })
        })
    }

    const getUniqueHistoryData = (data) => {
        const uniqueMap = new Map();
        data.forEach(item => {
            uniqueMap.set(item.id, item);
        });
        return Array.from(uniqueMap.values());
    };

    const handleReplyEmailClose = async (isRefresh, onReply = false) => {
        if (isRefresh || onReply) {
            if ((currentTab === 'email' || currentTab === 'all') && callerAssignedForEmail && activeTab === 'notes' && contacts?.length > 0) {
                let tmpCallerRegisteredEmails = []
                if (callerRegisteredEmails?.length === 0) {
                    let callers = user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.isCaller ? [callerAssignedForEmail, user?.id] : [callerAssignedForEmail]
                    tmpCallerRegisteredEmails = await dispatch(getRegisteredEmails(callers)).then(res => res).catch((err) => { if (err) { return [] } })
                }
                getEmailsForListSupHandler(callerAssignedForEmail, contacts, histories, currentTab, tmpCallerRegisteredEmails)
            }
        }
    }

    const handleBasicPhoneClick = (phoneNo) => {
        if (type === 'call') {
            setSupPhoneNumber(phoneNo)
            document.getElementById("main-content").scrollTop = 0
        }
    }

    const handleRemoveSupPhoneNumber = () => {
        setSupPhoneNumber('')
    }

    const PanelHeader = (headerText) => {
        return (
            <div className='d-flex align-items-center px-4 py-2'>
                <h4 className='mb-0 fw-bold'> {headerText} </h4>
                <div className='me-5 ms-auto'>
                    <button
                        type="button"
                        className="fs-4 px-4 p-3 text-white rounded mb-0 bg-dark-blue me-5"
                        onClick={(e) => { handleCreateChild(e) }}
                    >
                        Create Child
                    </button>
                </div>
            </div>
        )
    }

    const handleOnGetChildrenData = async () => {
        if (supplierInfo?.id) {
            await getChilds(supplierInfo?.id)
        } else {
            var vendorInCallDetailsId = null
            if (type === 'edit') {
                vendorInCallDetailsId = vendorInCallsDetailsId
            } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
                vendorInCallDetailsId = vendorInCallsDetails?.id
            }
            await getChilds(supplierInfo?.id, vendorId, true, vendorInCallDetailsId)
        }
    }

    const getChilds = async (masterId, listSupplierId = null, isInCalls = null, vendorInCallDetailsId = null) => {
        await dispatch(
            getChildSuppliersWithMasterId(masterId, listSupplierId, isInCalls, true, false, vendorInCallDetailsId)
        ).then(res => {
            setChildSuppliers(res?.length ? res : [])
        }).catch(err => {
            setChildSuppliers([])
        })
    }

    const handleAssignMaster = async (masterId = null) => {
        if (vendorId && masterId) {
            setIsLoadingAllListSupInfo(true)
            setIsLoadingListSupInfo(true)
            await dispatch(matchListSupplierToSupplier({
                id: vendorId,
                matchedSupplierId: masterId,
                status: 'Manually Matched Master'
            })).then(async () => {
                setIsRelaodPage(true)
                toast.show({
                    title: 'Success',
                    description: 'Successfully matched list supplier!'
                })

                await dispatch(createChildForListSupplier(
                    vendorId,
                    masterId,
                    currentDomain?.id,
                    user?.id,
                )).then(() => {
                }).catch(() => {
                    toast.show({
                        title: 'Warning',
                        description: 'Failed to create child supplier for list supplier!'
                    })
                })
                if (vendorInCallsDetails?.id) {
                    await dispatch(updateVendorInCallsDetailsById({
                        vendorInCallsDetailsId: vendorInCallsDetails?.id,
                        vendorInCallsDetails: {
                            ...vendorInCallsDetails,
                            workingEndTime: new Date(),
                        }
                    })).then((callsData) => {
                        setVendorInCallsDetails(callsData)
                    }).catch(() => {
                    })
                }
                setIsLoadingAllListSupInfo(false)
                setIsLoadingListSupInfo(false)
                history.push({ pathname: `/lists/insequence/${type === 'qa' ? 'qacallerdetails' : 'addcallerdetails'}/${vendorId}`, state: { matchedSupplierId: masterId } })
                setMatchedSupplierId(masterId);
            }).catch(() => {
                toast.show({
                    title: 'Error',
                    description: 'Failed to match list supplier!'
                })
                setIsLoadingAllListSupInfo(false)
                setIsLoadingListSupInfo(false)
            })
        }
    }

    const updateContactsHandler = (contactRes) => {
        if (contactRes?.length > 0) {
            setContacts(prevContacts => {
                const updatedContacts = [...(contactRes || []), ...prevContacts,];
                return updatedContacts.filter((item, index, self) =>
                    index === self.findIndex(t => t.id === item.id)
                );

            });
            setAllContacts(prevContacts => {
                const updatedContacts = [...(contactRes || []), ...prevContacts,];
                return updatedContacts.filter((item, index, self) =>
                    index === self.findIndex(t => t.id === item.id)
                );
            });
        } else {
            setContacts([])
            setAllContacts([])
        }

    }


    const getContactsData = async (supplierId = null, newMasterListSupplierId = null) => {
        let vendorInCallDetailsId = null
        let allContacts = []

        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }
        const supplierIds = []
        if (supplierId) {
            supplierIds.push(supplierId)
        } else if (supplierInfo?.id) {
            supplierIds.push(supplierInfo?.id)
        }
        if (newMasterListSupplierId) {
            await dispatch(getContacts({ supplierIds: supplierIds, listSupplierIds: [newMasterListSupplierId], supType: null, vendorInCallDetailsId })).then(res => {
                updateContactsHandler(res?.contacts)
            }).catch(() => {
                updateContactsHandler([]);
            });
        } else if (supplierIds?.length > 0) {
            await dispatch(getContacts({ supplierIds: supplierIds, supType: null })).then(res => {
                let createOptions = res?.contacts?.map((contact) => ({ label: contact?.email, name: contact?.id }))
                setContactOptions(createOptions || [])
                setContactsFromAddCallers(res?.contacts || [])
                updateContactsHandler(res?.contacts)
            }).catch(() => {
                updateContactsHandler([])
            })
        } else if ((vendorInfo?.id || vendorId || vendorInCallDetailsId)) {
            await dispatch(getContacts({ supplierIds: [], listSupplierId: vendorInfo?.id || vendorId, supType: null, vendorInCallDetailsId })).then(res => {
                setContactsFromAddCallers(res?.contacts || [])
                updateContactsHandler(res?.contacts)
            }).catch(() => {
                updateContactsHandler([])
            })
        }
        return allContacts
    }

    const handleCreateChild = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setShowCreateChild(true)
    }

    const handleClose = async (isGetChildData = false) => {
        setShowCreateChild(false)
        if (isGetChildData) {
            handleOnGetChildrenData()
        }
    }

    const onContactMouseHover = (event) => {
        if (event.target?.dataset?.contactId) {
            const contact = allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
            setCurrentContact(contact ? contact : {})
        } else {
            setCurrentContact({})
        }
        if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'block'
        }
    }

    const onContactMouseHoverOut = (event) => {
        if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'none'
        }
        setCurrentContact({})
    }

    const onContactNameClick = () => {
        setShowAllContacts(!showAllContacts)
        setExistedContacts(allContacts)
    }

    const onContactNameFocusOutClick = () => {
        setShowAllContacts(false)
        setExistedContacts(allContacts)
    }



    const countUnreadEmailsHandler = (parentEmailHistories, childEmailHistories) => {
        let countUnreadEmails = 0

        for (let index = 0; index < [...parentEmailHistories, ...childEmailHistories].length; index++) {
            const email = [...parentEmailHistories, ...childEmailHistories][index];
            if (!email?.isRead) {
                countUnreadEmails++
            }
        }
        setAllUnreadEmailCount(countUnreadEmails)
    }



    const updateNewEmails = useCallback(async () => {
        let tmpCallerRegisteredEmails = []
        let callers = []

        // if (user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.isCaller) {
        //     if (callerAssignedForEmail === user?.id) {
        //         callers = [callerAssignedForEmail]
        //     } else if (callerAssignedForEmail !== user?.id) {
        //         callers = [callerAssignedForEmail, user?.id]
        //     }
        // } else {
        //     callers = [callerAssignedForEmail]
        // }

        if (user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.isCaller) {
            if (callerAssignedForEmail === user?.id) {
                callers = [callerAssignedForEmail]
            } else if (callerAssignedForEmail !== user?.id) {
                callers = [callerAssignedForEmail]
            }
        } else {
            callers = [callerAssignedForEmail]
        }

        tmpCallerRegisteredEmails = await dispatch(getRegisteredEmails(callers)).then(res => res).catch((err) => { if (err) { return [] } })

        let tmpCallerRegEmailsOnly = tmpCallerRegisteredEmails?.map(regEmail => regEmail?.email?.toLowerCase())
        let tmpContactsEmailOnly = contacts?.map((contact) => contact?.email?.toLowerCase())

        let tmpValidUnreadEmails = unreadEmails.filter((unreadEmail) =>
            tmpCallerRegEmailsOnly?.includes(unreadEmail?.receiverEmail?.toLowerCase()) &&
            tmpContactsEmailOnly?.includes(unreadEmail?.senderEmail?.toLowerCase())
        );

        setParentEmailHistories((prevParentEmails) => {
            const updatedEmailHistories = [...prevParentEmails, ...childEmailHistories, ...tmpValidUnreadEmails];
            const { parentEmails, childEmails } = categorizeEmail(updatedEmailHistories);

            setChildEmailHistories(childEmails);
            return parentEmails;
        });

        setValidUnReadEmails(tmpValidUnreadEmails);
        // }
    }, [unreadEmails, histories])

    const onGetExistingContacts = (searchValue, type = '') => {
        try {
            dispatch(getExistingContacts({ searchValue, type })).then((res) => {
                if (res?.contacts && res?.contacts?.length > 0) {
                    if (supplierInfo?.id) {
                        res?.contacts.sort((a, b) => {
                            const aContains = a?.supplierIds.includes(supplierInfo?.id) ? 1 : 0;
                            const bContains = b?.supplierIds.includes(supplierInfo?.id) ? 1 : 0;
                            return bContains - aContains;
                        })
                    }

                    let createOptions = res?.contacts?.map((contact) => ({ label: contact?.email, name: contact?.id }))
                    setContactOptions([...contactOptions, ...createOptions])
                    setExistedContacts(res?.contacts)
                } else {
                    setExistedContacts([])
                    setContactOptions([])
                }
                setIsLoadingExistingContacts(false)
            }).catch(() => {
                setExistedContacts([])
                setIsLoadingExistingContacts(false)
            })
        } catch (err) {
            setExistedContacts([])
            setIsLoadingExistingContacts(false)
        }
    }

    const onCreateContact = () => {
        if ((currentCallData?.id || prevCallId)) {
            const [firstname, lastname] = contactName?.split(' ')
            setShowAddNewContact(true)
            setContactDataFromField({
                phone: dialedPhoneNumer,
                firstname: firstname?.trim() || '',
                lastname: lastname?.trim() || ''
            })
        } else {
            toast.show({
                title: 'Warning',
                description: 'There is no call found to link the contact!'
            })
        }
    }

    const handleContactClick = (rowData) => {
        if (!rowData?.contactName?.trim()) {
            toast.show({
                title: 'Warning',
                description: 'No contact name for this contact!'
            })
            return
        }
        const name = (rowData?.firstname || '') + (rowData?.lastname ? ' ' + rowData?.lastname : '')
        setContactName(rowData?.contactName?.trim())
        setContactNameId(rowData?.id || null)
        setShowAllContacts(false)

        if (rowData) {
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
            if (index === -1) {
                tmpContacts.push(rowData)
            }
            setAllContacts(tmpContacts)
        }
    }

    const handleCreateContactClose = (e, isGetContacts = false, contact = null) => {
        if (contact) {
            const name = (contact?.firstname || '') + (contact?.lastname ? ' ' + contact?.lastname : '')
            setContactName(name?.trim() || '')
            setContactNameId(contact?.id || null)
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            tmpContacts.push(contact)
            setAllContacts(tmpContacts)
            setExistedContacts(tmpContacts)
        }

        setShowAddNewContact(false)
        setShowAllContacts(false)
    }

    useBeforeunload(async (e) => {
        const isNotValidated = checkContactNameValidation()
        if (isNotValidated) {
            return
        }
        e.preventDefault()
        await handleOnOk(null)
    });

    const onLinkContactNameForAllCalls = async () => {
        if (((contactName?.trim() && contactNameId) || isRefusedToProvideName) && (currentCallData?.id || prevCallId)) {
            dispatch(linkContactNameForAllCalls({
                contactName: contactName?.trim(),
                contactId: contactNameId || null,
                vendorInCallsDetailsId: vendorInCallsDetails?.id || null,
                isRefusedToProvideName: isRefusedToProvideName || null
            })).then(() => {
                setContactName('')
                setContactNameId(null)
            }).catch(() => {
                setContactName('')
                setContactNameId(null)
            })
        }
    }

    const onRefusedToProvideNameChange = (checked) => {
        setIsRefusedToProvideName(checked)
        if (checked) {
            handleRemoveContact()
        }
    }

    const handleRemoveContact = () => {
        setContactName('')
        setContactNameId(null)
    }

    const checkContactNameValidation = () => {
        if ((currentCallData?.id || prevCallId)) {
            if ((!contactName?.trim() && !contactNameId) && !isRefusedToProvideName) {
                toast.show({
                    title: 'Warning',
                    description: 'Please add contact name or check refused to provide name!',
                })
                return true
            }
            return false
        }
        return false
    }

    var vendorInCallDetailsId = null
    if (type === 'edit') {
        vendorInCallDetailsId = vendorInCallsDetailsId
    } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
        vendorInCallDetailsId = vendorInCallsDetails?.id
    }

    var vendorInCallDetailsId = null
    if (type === 'edit') {
        vendorInCallDetailsId = vendorInCallsDetailsId
    } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
        vendorInCallDetailsId = vendorInCallsDetails?.id
    }

    const DownloadFile = (event) => {
        let currentFilename = event.currentTarget.dataset.filename
        dispatch(
            downloadFileFromS3Bucket({ filename: currentFilename })
        ).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", currentFilename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.show({
                title: 'Success',
                description: currentFilename + ' downloaded successfully!',
            })
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: "Unable to Download File!",
            })
        })
    }

    const reauthenticateHandler = async () => {
        let callers = user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.isCaller ? [callerAssignedForEmail, user?.id] : [callerAssignedForEmail]
        let tmpCallerRegisteredEmails = await dispatch(getRegisteredEmails(callers)).then(res => res).catch((err) => { if (err) { return [] } })
        googleLogin(true, callerAssignedForEmail, contacts, histories, currentTab, tmpCallerRegisteredEmails, 'addCallerDetails')
        setReauthenticateModal(false)
    }



    const handleNewMasterDetailsSave = async (supplierData = {}, cardInfo = {}, paymentInfo = {}, cardEmailsInfo = {}, feeData = {}, contactId = '', contactDataFromField = '', tmpContacts = {}) => {
        const tmpCardInfo = { ...cardInfo };
        delete tmpCardInfo.listSupplierId;
        delete tmpCardInfo.id;
        const tmpPaymentInfo = { ...paymentInfo };
        delete tmpPaymentInfo.listSupplierId;
        delete tmpPaymentInfo.id;
        const tmpFeeInfo = {};
        Object.keys(feeData).forEach((key) => {
            tmpFeeInfo[key] = { ...feeData[key] };
            tmpFeeInfo[key].supplierId = null;
            delete tmpFeeInfo[key].listSupplierId;
            delete tmpFeeInfo[key].vendorInCallsDetailsId;
        });
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : null
        const basicData = {}
        if (supplierData.employerIdNumber?.value && supplierData.employerIdNumber?.value !== '' && supplierInfo?.employerIdNumber !== supplierData.employerIdNumber?.value) {
            if (supplierData.employerIdNumber?.value !== '' && !/^(\d{2}-\d{7})?$/.test(supplierData.employerIdNumber?.value)) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid Employee Id Number. Must be 9 digit number formatted xx-xxxxxxx.'
                })
                return
            }

            const isEINExists = await dispatch(checkEmployerIdNumberExists({
                employerIdNumber: supplierData.employerIdNumber?.value,
                getEINData: true
            }))
            if (isEINExists?.einResult[0]?.id) {
                setSupNameForEIN(isEINExists?.einResult[0])
            } else {
                setSupNameForEIN({})
            }
            if (isEINExists?.einCount && isEINExists?.einCount > 0) {
                toast.show({
                    title: 'Warning',
                    description: 'Employer Id Number : ' + supplierData.employerIdNumber?.value + ' already exists!'
                })
                return
            }
        }

        Object.keys(supplierData).forEach(key => {
            if (key !== 'id') {
                basicData[key] = supplierData[key].value
            }
        })
        setIsLoading({ ...isLoading, basicInfo: true })

        var vendorInCallDetailsId = null
        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id
        }
        if (!Object.keys(newMasterSupplierBasicInfo?.baseInfo || {})?.length > 0) {
            dispatch(createMasterSupplierBasicInfo(basicData, tmpCardInfo, tmpPaymentInfo, matchedSupplierId, tmpFeeInfo)).then(async (res) => {
                const tempSupplierInfo = { baseInfo: supplierInfo || {} }
                supplierId = res?.supplier?.id;
                const cardInfo = res?.['cardInfo'] || {}
                cardInfo['cardFeeInfo'] = res?.cardFeeData || []
                cardInfo['cardEmailsInfo'] = []

                const allContacts = await getContactsData(null, res?.supplier?.id)
                await addListMasterSupplierHistory(supplierId, vendorInCallDetailsId, tempSupplierInfo, res?.supplier, 'basic', '', true, null, true, allContacts)
                setNewMatchedSupplierId(res?.supplier?.id)

                if (cardEmailsInfo && Object.keys(cardEmailsInfo)?.length > 0) {
                    cardInfo['cardEmailsInfo'] = await dispatchEmailsData(cardEmailsInfo, null, res?.supplier?.id, vendorInCallDetailsId, true)
                }

                setSupplierOldCardInfo(cardInfo)
                setSupplierOldPaymentInfo({ paymentInfo: res?.payment })
                setSupplierOldInfo({ baseInfo: res?.supplier })
                setnewMasterSupplierBasicInfo({ baseInfo: res?.supplier, cardInfo: cardInfo, paymentInfo: res?.paymentInfo })
                toast.show({
                    title: 'Success',
                    description: 'Supplier Basic Info created successfully!',
                })
                setIsLoading({ ...isLoading, basicInfo: false })
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create Supplier Basic Info!',
                })
                setIsLoading({ ...isLoading, basicInfo: false })
            })
        } else {
            if (contactId && contactDataFromField && tmpContacts) {
                const matchedContact = tmpContacts.find(contact => contact.id === contactId);
                if (matchedContact) {
                    if (contactDataFromField === "email") {
                        basicData.emailContactId = matchedContact.id;
                        basicData.email = matchedContact.email || "";
                    } else if (contactDataFromField === "phone") {
                        basicData.phoneContactId = matchedContact.id;
                        basicData.phone = matchedContact.phone || "";
                    }
                }
            }

            dispatch(updateMasterSupplierBasicInfo(basicData, matchedSupplierId, newMasterSupplierBasicInfo?.baseInfo?.id)).then(async (res) => {
                const listSupplierId = res?.updatedSupplier?.id;
                var allContacts = await getContactsData(newMatchedSupplierId)
                setMatchedSupplierDetailInfo(res?.updatedSupplier)
                await addListMasterSupplierHistory(listSupplierId, vendorInCallDetailsId, activeKey === 'reenablement' ? newMasterSupplierBasicInfo : supplierOldInfo, res?.updatedSupplier, 'basic', '', true, matchedSupplierId, true, allContacts)
                setSupplierOldInfo({ baseInfo: res?.updatedSupplier })
                toast.show({
                    title: 'Success',
                    description: 'Supplier Basic Info updated successfully!',
                })
                setIsLoading({ ...isLoading, basicInfo: false })
                setnewMasterSupplierBasicInfo({
                    ...newMasterSupplierBasicInfo,
                    baseInfo: res?.updatedSupplier
                })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to update Supplier Basic Info!',
                })
                setIsLoading({ ...isLoading, basicInfo: false })
            })
        }
    }

    const handleNewMatchedCardAccDataSave = async (cardInfo = {}, feeData = {}, addedEmailsValues = {}, removeEmailValues = {}) => {
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : (supplierInfo.id || null)
        const cardData = {}

        Object.keys(cardInfo)?.forEach(key => {
            const currentValue = cardInfo[key];
            if (multiSelectColumns.includes(key) && Array.isArray(currentValue)) {
                const cardSelectOptions = currentValue.map(option => option?.value)?.join(",");
                cardData[key] = cardSelectOptions;
            } else if (key === 'cardAuthorizationFormFile' && typeof currentValue === 'string') {
                cardData[key] = currentValue;
            } else if (currentValue?.value !== undefined) {
                cardData[key] = currentValue.value;
            } else {
                cardData[key] = (typeof currentValue === 'object' && !Array.isArray(currentValue) && Object.keys(currentValue).length === 0)
                    ? null
                    : currentValue;
            }
        });

        var vendorInCallDetailsId = null;
        if (type === 'edit') {
            vendorInCallDetailsId = vendorInCallsDetailsId;
        } else if ((isIncomingCall || (location?.state && location?.state?.IsIncomingCall)) && matchData?.length === 0) {
            vendorInCallDetailsId = vendorInCallsDetails?.id;
        }

        function cleanPayload(obj) {
            return Object.entries(obj).reduce((acc, [key, value]) => {
                if (value && typeof value === 'object' && !Array.isArray(value)) {
                    if (Object.keys(value).length === 0) {
                        acc[key] = null;
                    } else {
                        acc[key] = cleanPayload(value);
                    }
                } else {
                    acc[key] = value;
                }
                return acc;
            }, {});
        }

        const cleanedCardData = cleanPayload(cardData);

        dispatch(updateNewMasterSupplierCardInfo(cleanedCardData, newMatchedSupplierId ? newMatchedSupplierId : matchedSupplierDetailInfo.id, feeData)).then(async (res) => {
            const cardInfo = res?.['cardInfo'] || {}
            cardInfo['cardEmailsInfo'] = newMasterSupplierBasicInfo?.cardInfo?.cardEmailsInfo || []
            if (addedEmailsValues && Object.keys(addedEmailsValues)?.length > 0) {
                cardInfo['cardEmailsInfo'] = await dispatchEmailsData(addedEmailsValues, null, newMatchedSupplierId ? newMatchedSupplierId : matchedSupplierDetailInfo.id, vendorInCallDetailsId, true)
            }
            if (removeEmailValues && Object.keys(removeEmailValues)?.length > 0) {
                cardInfo['cardEmailsInfo'] = await removeCardEmails(removeEmailValues, null, newMatchedSupplierId ? newMatchedSupplierId : matchedSupplierDetailInfo.id, vendorInCallDetailsId, true)
            }

            cardInfo['cardFeeInfo'] = await dispatch(getCardAcceptanceFee(newMatchedSupplierId ? newMatchedSupplierId : matchedSupplierDetailInfo.id, vendorInCallDetailsId, true))

            const allContacts = await getContactsData(null, res?.['cardInfo']?.listSupplierId)
            await addListMasterSupplierHistory(res?.['cardInfo']?.listSupplierId, vendorInCallDetailsId, supplierOldCardInfo, res?.['cardInfo'], 'card', '', true, null, true, allContacts)
            setSupplierOldCardInfo(cardInfo)
            setnewMasterSupplierBasicInfo({
                ...newMasterSupplierBasicInfo,
                cardInfo: cardInfo
            })
            toast.show({
                title: 'Success',
                description: 'Supplier Card Info updated successfully!',
            })
            setIsLoading({ ...isLoading, cardInfo: false })
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to update Supplier Card Info!',
            })
            setIsLoading({ ...isLoading, cardInfo: false })
        })
    }

    const handleCheckMasterDataSave = (checkInfo, achInfo) => {
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : (supplierInfo.id || null)
        const achData = {}
        const checkData = {}
        Object.keys(achInfo).forEach(key => {
            achData[key] = achInfo?.[key]?.value
        })
        Object.keys(checkInfo).forEach(key => {
            checkData[key] = checkInfo?.[key]?.value
        })
        setIsLoading({ ...isLoading, checkInfo: true })
        const paymentInfo = { ...checkData }
        delete paymentInfo?.id
        dispatch(updateNewMasterSupplierPaymentInfo(paymentInfo, newMatchedSupplierId ? newMatchedSupplierId : matchedSupplierDetailInfo.id)).then(async (res) => {
            var oldSupplierPaymentInfo = { paymentInfo: newMasterSupplierBasicInfo?.paymentInfo }
            await getContactsData(null, res?.listSupplierId)
            await addListMasterSupplierHistory(res?.listSupplierId, vendorInCallDetailsId, supplierOldPaymentInfo, res, 'check', '', true)
            setnewMasterSupplierBasicInfo({
                ...newMasterSupplierBasicInfo,
                paymentInfo: res
            })
            setSupplierOldPaymentInfo({ paymentInfo: res })
            toast.show({
                title: 'Success',
                description: 'Supplier Check Info updated successfully!',
            })
            setIsLoading({ ...isLoading, checkInfo: false })
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to update Supplier Check Info!',
            })
            setIsLoading({ ...isLoading, checkInfo: false })
        })
    }

    const handleACHMasterDataSave = async (achInfo = {}, checkInfo = {}) => {
        var supplierId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : (supplierInfo.id || null)

        const achData = {}
        const checkData = {}
        // achData['supplierId'] = supplierInfo?.id || null
        Object.keys(achInfo)?.forEach(key => {
            if (key === 'achInstructions' && typeof achInfo?.[key] === 'string') {
                achData[key] = achInfo?.[key]
            } else {
                achData[key] = achInfo?.[key]?.value
            }
        })
        Object.keys(checkInfo)?.forEach(key => {
            checkData[key] = checkInfo?.[key]?.value
        })
        const paymentInfo = { ...achData }
        delete paymentInfo?.id
        setIsLoading({ ...isLoading, achInfo: true })
        dispatch(updateNewMasterSupplierPaymentInfo(paymentInfo, newMatchedSupplierId ? newMatchedSupplierId : matchedSupplierDetailInfo.id)).then(async (res) => {
            var oldSupplierPaymentInfo = { paymentInfo: newMasterSupplierBasicInfo?.paymentInfo }
            const allContacts = await getContactsData(null, res?.listSupplierId)
            await addListMasterSupplierHistory(res?.listSupplierId, vendorInCallDetailsId, oldSupplierPaymentInfo, res, 'ach', '', true, null, true, allContacts)
            const result = allContacts.find(item => item.id === Number(res?.emailAch));
            const email = result ? result.email : null;
            res['emailAch'] = email
            setSupplierOldPaymentInfo({ paymentInfo: res })
            setnewMasterSupplierBasicInfo({
                ...newMasterSupplierBasicInfo,
                paymentInfo: res
            })
            toast.show({
                title: 'Success',
                description: 'Supplier ACH Info updated successfully!',
            })
            setIsLoading({ ...isLoading, achInfo: false })
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to update Supplier ACH Info!',
            })
            setIsLoading({ ...isLoading, achInfo: false })
        })
    }

    const handleBasicInfoCreate = (isBasicInfoCreate) => {
        setIsNewBasicInfo(isBasicInfoCreate)
    }

    const getCallRecordingsHandler = async () => {
        let matchedSupId = null
        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }
        let supId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : null

        const callRecordings = await dispatch(getCallRecordings(vendorId, vendorInCallDetailsId, supId)).then((res) => res).catch((err) => { if (err) { return [] } })
        setCallRecordings(callRecordings)
    }

    useEffect(() => {
        let oldBasicInfo = {};
        let matchedSupId = null
        let supId = null

        if (location?.search && location?.search?.includes('matchedSupplierId')) {
            matchedSupId = location?.search.split('?')?.[1]?.split('=')?.[1]
        }

        supId = supplierId ? supplierId : location?.state?.matchedSupplierId ? location?.state?.matchedSupplierId : matchedSupId ? matchedSupId : null;

        if (activeKey === 'reenablement') {
            setMatchedSupplierId(vendorId)
        } else {
            setMatchedSupplierId(supId);
        }
        if (!location?.pathname.includes('addcallerdetails') &&
            !location?.pathname.includes('qacallerdetails') &&
            !location?.pathname.includes('editcallerdetails')) {
            return;
        }
        if (location?.state && location?.state?.IsShowAddCallerDetails) {
            return
        }
        if (location?.state && location?.state?.IsIncomingCall) {
            setIsIncomingCall(true)
            setMatchData(location?.state?.matchedSupplier ? JSON?.parse(location?.state?.matchedSupplier) : [])
            setIncomingPhoneNo(location?.state?.phoneNumber)
            setCallerId(location?.state?.callerId)
        }
        setIsRelaodPage(false)
        if ((vendorId || vendorInCallsDetailsId || supId) && !location?.state?.IsShowAddCallerDetails) {
            var vendorInCallDetailsId = null
            if (type === 'edit') {
                vendorInCallDetailsId = vendorInCallsDetailsId
            }

            setIsLoadingAllListSupInfo(true)
            //fetching masters data
            dispatch(getAllListSupplierInfo({
                listSupplierId: activeKey === 'reenablement' ? vendorId : supId ? null : vendorId,
                vendorInCallsDetailsId: supId ? null : vendorInCallDetailsId,
                supplierId: activeKey === 'reenablement' ? vendorId : supId
            })).then(async (result) => {
                const cardInfo = {};
                let files = []

                oldBasicInfo = result; // Moved assignment of oldBasicInfo here
                cardInfo['cardInfo'] = result?.['cardInfo'] || {};
                cardInfo['cardFeeInfo'] = await dispatch(getCardAcceptanceFee(supId ? null : vendorId, supId ? null : vendorInCallDetailsId, true, activeKey === 'reenablement' ? vendorId : supId));
                cardInfo['cardEmailsInfo'] = await dispatch(getCardAcceptanceEmails(supId ? null : vendorId, supId ? null : vendorInCallDetailsId, true, activeKey === 'reenablement' ? vendorId : supId || result?.baseInfo?.id));
                const history = await dispatch(getHistoryData(supId ? null : vendorId, supId ? null : vendorInCallDetailsId, true, activeKey === 'reenablement' ? vendorId : supId)).then(res => res).catch(err => {
                    toast.show({
                        title: 'Warning',
                        description: 'Failed to get history data',
                    })
                })
                const callRecordings = await dispatch(getCallRecordings(activeKey === 'reenablement' ? null : vendorId, vendorInCallDetailsId, activeKey === 'reenablement' ? vendorId : supId)).then((res) => res).catch(err => {
                    toast.show({
                        title: 'Warning',
                        description: 'Failed to get call recording data',
                    })
                })

                let historyData = [...history, ...callRecordings];
                historyData = historyData.sort((first, second) => {
                    let firstDate = first.hasOwnProperty('isRecorded') ? first.callStartTime : first.updatedDate
                    let secondDate = second.hasOwnProperty('isRecorded') ? second.callStartTime : second.updatedDate
                    return secondDate > firstDate ? 1 : -1;
                });

                if (result?.baseInfo && result?.baseInfo?.id) {
                    await getChilds(result?.baseInfo?.id)
                } else {
                    await getChilds(supplierInfo?.id, vendorId, true, vendorInCallDetailsId)
                }

                if (!supId && activeKey !== 'reenablement') {
                    await getContactsData(result?.baseInfo?.id)
                }
                setAllHistoryData(historyData)
                setSupplierInfo(result?.baseInfo)
                setSupplierOldInfo({ baseInfo: result?.baseInfo })
                setSupplierOldCardInfo({ cardInfo: result?.['cardInfo'] })
                setSupplierPaymentInfo(result?.paymentInfo)
                setSupplierOldPaymentInfo({ paymentInfo: result?.paymentInfo })
                setSupplierCardInfo(cardInfo)
                setIsLoadingAllListSupInfo(false)

                if (hash === '' || !hash) {
                    window.scrollTo(0, 0);
                } else {
                    setTimeout(() => {
                        const id = hash.replace('#', '');
                        const element = document.getElementById(id);
                        if (element) {
                            element.scrollIntoView();
                        }
                    }, 0);
                }

                result?.paymentInfo?.achInstructions && files.push({ note: result?.paymentInfo?.achInstructions, createdDate: result?.paymentInfo?.updatedAt, fileType: 'ACH Payment Instructions File' })
                cardInfo?.cardAuthorizationFormFile && files.push({ note: cardInfo?.cardAuthorizationFormFile, createdDate: cardInfo?.updatedAt, fileType: 'Card Authorization Form File' })
                setFiles(files)
            }).catch(() => {
                setIsDisabledButtons(true)
                setIsLoadingAllListSupInfo(false)
                toast.show({
                    title: 'Warning',
                    description: 'Failed to get Master Supplier Info!'
                })
            })
            if (vendorId) {
                setIsLoadingListSupInfo(true);

                const fetchData = activeKey === 'reenablement'
                    ? dispatch(getMasterSupplierDetailsById(vendorId))
                    : dispatch(getListSupplierDetailById(vendorId));

                fetchData
                    .then(async (response) => {
                        let result = {};
                        if (activeKey === 'reenablement') {
                            const callDetails = await dispatch(getSupplierCallDetailsById({ supplierId: vendorId })).then((res) => res).catch(err => {
                                toast.show({
                                    title: 'Warning',
                                    description: 'Failed to get supplier call details by id!'
                                })
                                return []
                            })

                            const supplierInfo = response?.supplierInfo || {};
                            result = {
                                ...supplierInfo,
                                vendorsInCall: callDetails
                            };
                        } else {
                            result = response || {};
                        }
                        setVendorInfo(result) //either master or list supplier data is set
                        setCallerAssignedForEmail(result?.vendorsInCall?.callerAssigned)
                        setVendorInCallData(result?.vendorsInCall)
                        let script = result?.callingScript?.script
                        if (script) {
                            if (script?.includes('@suppliername')) {
                                script = script?.replaceAll('@suppliername', `<b><em>${result?.suppliername}</em></b>`)
                            }

                            if (script?.includes('@partnerName')) {
                                script = script?.replaceAll('@partnerName', `<b><em>${vendorInCallsData?.partnerName}</em></b>`)
                            }

                            if (script?.includes('@companyName')) {
                                script = script?.replaceAll('@companyName', `<b><em>${vendorInCallsData?.companyName}</em></b>`)
                            }

                            if (script?.includes('@contactName')) {
                                script = script?.replaceAll('@contactName', `<b><em>${vendorInCallsData?.contactName}</em></b>`)
                            }
                        }
                        setCallingScript(script)
                        setIsLoadingListSupInfo(false)
                    }).catch(() => {
                        setIsLoadingListSupInfo(false)
                    })
            } else {
                setVendorInCallData(vendorInCallsData)
            }
        } else {
            setVendorInfo([])
            setSupplierInfo({})
            setSupplierOldInfo({})
            setSupplierCardInfo({})
            setSupplierOldCardInfo({})
            setSupplierPaymentInfo({})
            setSupplierOldPaymentInfo({})
            setHistoryData([])
            setCallingScript(null)
            setVendorInCallData({})
        }
        if (type === 'call') {
            if (location?.pathname.includes('addcallerdetails') && (!location?.state?.IsIncomingCall || !incomingCall)) {
                const callDetails = {}
                dispatch(addVendorInCallsDetails({
                    callDetails: {
                        ...callDetails,
                        callerAssigned: vendorInCallsData?.callerAssigned,
                        listSupplierId: vendorInCallsData?.listSupplierId,
                        vendorsInCallId: vendorInCallsData?.id,
                        workingStartTime: new Date(),
                        contactType: 'phone'
                    }
                })).then(callsData => {
                    setVendorInCallsDetails(callsData)
                }).catch((err) => {
                    console.log('callsData', err)
                })
            } else if (location?.state && (location?.state?.IsIncomingCall || incomingCall)) {
                var matchedSup = location?.state?.matchedSupplier ? JSON?.parse(location?.state?.matchedSupplier) : []
                if (matchedSup?.length === 0) {
                    dispatch(linkCallerDetailsLater({
                        callDetails: {
                            listSupplierId: null,
                            callerAssigned: user?.id,
                            dateMovedToCalls: new Date(),
                        },
                        vendorInCallsDetails: {
                            listSupplierId: null,
                            callerAssigned: user?.id,
                            isLinkedLater: true,
                            assumedVendorName: location?.state?.supName || '',
                            workingStartTime: new Date(),
                            contactType: 'phone'
                        }
                    })).then((res) => {
                        setVendorInCallsDetails(res?.vendorInCallDetails)
                        setVendorInCallData(res?.calldetails)
                    }).catch(() => {

                    })
                } else {
                    const callDetails = {}
                    dispatch(addVendorInCallsDetails({
                        callDetails: {
                            ...callDetails,
                            workingStartTime: new Date(),
                            contactType: 'phone',
                            assumedVendorName: location?.state?.supName || ''
                        }
                    })).then(callsData => {
                        setVendorInCallsDetails(callsData)
                    }).catch((err) => {
                        console.log('callsData', err)
                    })
                }
            }
        }
    }, [location, activeKey])

    useEffect(() => {
        if (matchedSupplierId || activeKey === 'reenablement') {
            const masterSupplierId = activeKey === 'reenablement' ? vendorId : matchedSupplierId
            dispatch(getNewMasterListSupplierInfo({ matchedSupplierId: masterSupplierId }))
                .then(async (newResult) => {
                    if (Object?.keys(newResult)?.length > 0) {
                        newResult.cardInfo['cardFeeInfo'] = await dispatch(getCardAcceptanceFee(newResult?.baseInfo?.id, null, true, null));
                        newResult.cardInfo['cardEmailsInfo'] = await dispatch(getCardAcceptanceEmails(newResult?.baseInfo?.id, null, true, null));
                        const supplierContact = await getContactsData(masterSupplierId, newResult?.baseInfo?.id);
                        const result = supplierContact.find(item => item.id === Number(newResult?.paymentInfo?.emailAch));
                        const email = result ? result.email : null;
                        newResult.paymentInfo['emailAch'] = email || null
                        newResult.paymentInfo['emailContactId'] = result?.id || null
                        setMatchedSupplierDetailInfo(newResult?.baseInfo || {}); //matched list supplier info is set
                        setnewMasterSupplierBasicInfo(newResult || {});
                    }
                })
                .catch((error) => {
                    setMatchedSupplierDetailInfo({});
                    setnewMasterSupplierBasicInfo({});
                    toast.show({
                        title: 'Warning',
                        description: 'Failed to get List Supplier Data!'
                    });
                });
        }
    }, [matchedSupplierId])

    useEffect(() => {
        if (matchedSupplierDetailInfo?.id) {
            getNewHistory(matchedSupplierDetailInfo?.id)
        } else {

            setAllHistoryData(histories)
        }
    }, [matchedSupplierDetailInfo, histories, showCreateChild, historyData])

    useEffect(() => {
        if (newMasterSupplierBasicInfo && newMasterSupplierBasicInfo?.baseInfo?.id) {
            setSupplierOldInfo({ baseInfo: newMasterSupplierBasicInfo?.baseInfo });
            setSupplierOldCardInfo({ cardInfo: newMasterSupplierBasicInfo?.cardInfo });
            setSupplierOldPaymentInfo({ paymentInfo: newMasterSupplierBasicInfo?.paymentInfo });
        }
    }, [newMasterSupplierBasicInfo, supplierInfo])

    useEffect(async () => {
        dispatch(getStatesToNotRecordCalls()).then(states => {
            setStatesToNotRecordCalls(states)
        }).catch(() => {
            setStatesToNotRecordCalls([])
        })

        if (socketIo) {
            socketIo.on("callStatus", (callStatus) => {
                const statusUpdate = JSON?.parse(callStatus);
                setCallStatus(statusUpdate)
            });

            socketIo.on("gettingCallRecordings", (data) => {
                setIsLoadingAllListSupInfo(true)
            });

            socketIo.on("callRecordingUpdate", (callrecordings) => {
                const updatedRecordings = JSON?.parse(callrecordings);
                setCallRecordings(updatedRecordings)
            });

            socketIo.on("addedCallDetails", (callDetails) => {
                const callDetailsData = JSON?.parse(callDetails);
                setInboundCallDetails(callDetailsData)
            });

            socketIo.on("getCallRecordings", async (data) => {
                const parsedData = JSON?.parse(data);
                if (parsedData.listSupplierId || parsedData?.vendorsInCallsDetailId) {
                    const callRecordings = await dispatch(getCallRecordings(parsedData?.listSupplierId, parsedData?.vendorsInCallsDetailId))
                    setCallRecordings(callRecordings)
                }
            });
        }
    }, [])

    useEffect(() => {
        if (callStatus) {
            const { CallStatus } = callStatus
            let outgoingCallHangupButton = document.getElementById('cut-call')
            let incomingCallEndButton = document.getElementById('end-call')
            switch (CallStatus) {
                case 'initiated':
                    if (outgoingCallHangupButton && !callStatus?.CalledVia) {
                        handleCreateCallRecord(callStatus)
                    }
                    break;
                case 'ringing':
                    console.log('Ringing', '\n\n')
                    break;
                case 'in-progress':
                    setCallStartTime(Date.now());
                    setStatus('In-Progress');
                    if (incomingCall || isIncomingCall) {
                        const isState = statesToNotRecordCalls?.find(state => state?.stateCode === callStatus?.FromState)
                        setIsRecordCurrentCall(isState ? false : true)
                    } else {
                        if (outgoingCallHangupButton) {
                            handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration, 'answered')
                        }
                    }
                    break;
                case 'answered':
                    setStatus('answered');
                    break;
                case 'completed':
                    setCallStartTime(null);
                    setStatus('');
                    if (incomingCall || isIncomingCall) {
                        handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid, 'inbound')
                        setIsIncomingCall(false)
                        dispatch({
                            type: END_INCOMING_CALL
                        })
                    } else {
                        if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                            if (call) {
                                outgoingCallHangupButton.click()
                            }
                            handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration)
                            handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid)
                        }
                    }
                    break;
                case 'busy':
                    setCallStartTime(null)
                    if (incomingCall || isIncomingCall) {
                        setIsIncomingCall(false)
                        dispatch({
                            type: END_INCOMING_CALL
                        })
                    } else {
                        if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                            if (call) {
                                outgoingCallHangupButton.click()
                            }
                            handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration, 'rejected')
                            handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid)
                        }
                    }
                    setStatus('');
                    break;
                case 'failed':
                    setStatus('');
                    setCallStartTime(null)
                    if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                        if (call) {
                            outgoingCallHangupButton.click()
                        }
                        handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration, 'failed')
                        handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid)
                    }
                    break;
                case 'no-answer':
                    setStatus('');
                    setCallStartTime(null)
                    if (incomingCall || isIncomingCall) {
                        setIsIncomingCall(false)
                        dispatch({
                            type: END_INCOMING_CALL
                        })
                    } else {
                        if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                            if (call) {
                                outgoingCallHangupButton.click()
                            }
                            handleUpdateCallDetails(callStatus?.ParentCallSid, callStatus?.CallDuration, 'no-answer')
                            handleUpdateCallRecord(callStatus?.CallDuration, callStatus?.ParentCallSid)
                        }
                    }
                    break;
                case 'canceled':
                    setStatus('');
                    setCallStartTime(null)
                    if (callStatus?.Direction !== 'inbound' && outgoingCallHangupButton) {
                        if (call) {
                            outgoingCallHangupButton.click()
                        }
                    }
                    break;
                default:
                    break;
            }
        }
    }, [callStatus])

    useEffect(() => {
        if (callRecordings?.length) {
            setIsLoadingAllListSupInfo(true)
            var historydata = [...historyData, ...callRecordings]
            historydata = historydata.sort((first, second) => {
                let firstDate = first.hasOwnProperty('isRecorded') ? first.callStartTime : first.updatedDate
                let secondDate = second.hasOwnProperty('isRecorded') ? second.callStartTime : second.updatedDate
                return secondDate > firstDate ? 1 : -1;
            });
            historydata = [...new Map(historydata?.map(item =>
                [item['id'], item])).values()];
            setHistoryData(historydata)
            setIsLoadingListSupInfo(false)
            setIsLoadingAllListSupInfo(false)
        } else {
            setHistoryData(historyData)
            setIsLoadingListSupInfo(false)
        }
    }, [callRecordings])


    useEffect(() => {
        if (Object.keys(inboundCallDetails)?.length) {
            dispatch(createCallRecord({
                callerAssigned: vendorInCallData?.callerAssigned,
                listSupplierId: vendorInCallData?.listSupplierId,
                vendorInCallsId: vendorInCallData?.id,
                callType: 'inbound',
                callStartTime: inboundCallDetails?.startTime,
                dateCalled: inboundCallDetails?.startTime,
                callSid: inboundCallDetails?.callSid,
                vendorsInCallsDetailId: vendorInCallsDetails?.id || null,
                isRecorded: isRecordCurrentCall
            })).then(calldata => {
                setCurrentCallData(calldata)
                setPrevCallId(calldata?.id)
            }).catch(() => {
                setCurrentCallData({})
                setPrevCallId(null)
            })
        }
    }, [inboundCallDetails])

    useEffect(() => {
        let histories = [...allHistoryData];
        if (vendorInfo?.histories?.length > 0) {
            histories = [...historyData, ...vendorInfo?.histories]
            histories = histories.sort((first, second) => {
                let firstDate = first.hasOwnProperty('isRecorded') ? first.callStartTime : first.updatedDate
                let secondDate = second.hasOwnProperty('isRecorded') ? second.callStartTime : second.updatedDate
                return secondDate > firstDate ? 1 : -1;
            });
            if (histories?.length) {
                histories = getUniqueHistoryData(histories)
            }
        }
        let tmpHistories = histories?.map(item => item)

        let notes = tmpHistories?.filter((history) => history?.type === 'note') || [];
        let changelog = tmpHistories?.filter((history) => history?.type === 'changelog') || [];

        setHistories(histories)
        setNotes(notes);
        setChangeLog(changelog);

    }, [vendorInfo?.histories, historyData, callerAssignedForEmail, activeTab, currentTab, emailsToReauthenticate, contacts])

    useEffect(() => {
        if (((currentTab === 'email' || currentTab === 'all') && callerAssignedForEmail && activeTab === 'notes') && contacts?.length > 0) {
            let callers = user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.isCaller ? [callerAssignedForEmail, user?.id] : [callerAssignedForEmail]

            dispatch(getRegisteredEmails(callers)).then(res => {
                getEmailsForListSupHandler(callerAssignedForEmail, contacts, histories, currentTab, res)
            }).catch((err) => { if (err) { return [] } })

            if (currentTab === 'email') {
                setIsLoadingHistories(false)
            } else if (currentTab === 'all') {
                setIsLoadingEmailHistories(false)
            }
        } else {
            clearStates()
        }
    }, [callerAssignedForEmail, activeTab, currentTab, emailsToReauthenticate, contacts])

    useEffect(() => {
        if (contactName?.trim() && contactName?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(contactName?.trim(), 'phone')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            setIsLoadingExistingContacts(false)
        }
    }, [contactName])

    useEffect(() => {
        countUnreadEmailsHandler(parentEmailHistories, childEmailHistories)
        sortHistories(allHistoryData, parentEmailHistories);
    }, [parentEmailHistories, childEmailHistories, allHistoryData]);

    useEffect(() => {
        updateNewEmails()
    }, [unreadEmails, updateNewEmails])

    useEffect(() => {
        googleTokensValidationHandler([callerAssignedForEmail])
        getSubscriptions()
    }, []);

    return (
        <>
            {reauthenticateModal && emailsToReauthenticate && <Modal backdrop={true} className="" show={reauthenticateModal} size="sm">
                <Modal.Header>
                    <h3 className="mb-0 fw-bold">Tokens Expired</h3>
                </Modal.Header>
                <Modal.Body className='p-0'>
                    <h4 className='p-0'>Your tokens are expired for <span className='fw-bold'>{emailsToReauthenticate}</span></h4>
                    <p className='fs-4 p-0'>Please re-authenticate again</p>
                </Modal.Body>
                <Modal.Footer >
                    <button className='report_button_secondary' onClick={reauthenticateHandler}>OK</button>
                </Modal.Footer>
            </Modal>}

            <Beforeunload onBeforeunload={() => 'You\'ll lose your data!'} >
                {type === 'call' && !isReloadPage && (
                    <NavigationPrompt
                        when={true}
                        beforeConfirm={(clb) => { handleOnOk(clb) }}
                    >
                        {({ onConfirm, onCancel }) => (
                            <Modal show={true} onHide={onCancel}>
                                <Modal.Header className={`${isLoading?.updateVendorInCall ? 'position-relative loading' : ''}`}>
                                    {isLoading?.updateVendorInCall && <LoaderComponent />}
                                    <h2 className='mb-0'>Do you want to save your unfinished work?</h2>
                                    <div className='mt-4'>
                                        <button className='pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white float-end width-100' onClick={onCancel}>Cancel</button>
                                        <button className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto float-end width-100' onClick={onConfirm}>Ok</button>
                                    </div>
                                </Modal.Header>
                            </Modal>
                        )}
                    </NavigationPrompt>
                )}
                <div id="add-caller-details-page" className={`add-caller-details-page assign-vendor-component master-supplier-history-panel mt-5 p-0 position-relative${isApprovingOrRejecting ? ' loading' : ''}`}>
                    {isApprovingOrRejecting && <LoaderComponent />}

                    {isDisabledButtons && (
                        <div className='error-note mb-4'>
                            <h2 className='text-danger fw-bold'>Failed to get master supplier info. Please reload page or go to In Sequence page and re-open this list supplier.</h2>
                        </div>
                    )}
                    <div className='d-flex flex-column'>
                        <div className='mb-3'>
                            <h2 className='fw-bold' style={{ color: '#214466' }}>{vendorInfo?.suppliername?.toUpperCase()}</h2>
                        </div>
                        <div className='d-flex column-gap-4'>
                            <button
                                className=' rounded-top fw-bold border'
                                style={{ backgroundColor: activeTab === 'emails' ? 'white' : '#214466', color: activeTab === 'emails' ? 'black' : 'white', width: 160, height: 40, fontSize: 16 }}
                                onClick={() => { setActiveTab('notes'); clearStates() }}
                            >Note
                            </button>
                            <button
                                className='rounded-top fw-bold border'
                                style={{ backgroundColor: activeTab !== 'emails' ? 'white' : '#214466', color: activeTab !== 'emails' ? 'black' : 'white', width: 160, height: 40, fontSize: 16 }}
                                onClick={() => { setActiveTab('emails') }}
                            >
                                Email
                            </button>
                        </div>
                        <div className='d-flex gap-4'>
                            {activeTab === 'notes' && <div className={`caller-notes-container d-flex flex-column border rounded p-4 gap-3 flex-grow-1 position-relative${isLoadingAllListSupInfo ? ' loading' : ''}`}>
                                {isLoadingAllListSupInfo && <Loader />}
                                <h3 className='fw-bold text-blue'> Caller Notes </h3>
                                <div className='supplier-history-editor-parent'>
                                    <h3 className='fw-bold text-black'> Add Note </h3>
                                    <Editor
                                        editorState={editorState}
                                        toolbarClassName={`supplier-history-editor-toolbar ${hideEditorClass}`}
                                        wrapperClassName="supplier-history-editor-wrapper flex"
                                        editorClassName="supplier-history-editor h5"
                                        onEditorStateChange={updateTextDescription}
                                        mention={{
                                            separator: ' ',
                                            trigger: '@',
                                            suggestions: userSuggestion,
                                        }}
                                    />
                                    <div className={`notes-editor-custom-buttons flex ${hideEditorClass}`}>
                                        <button className='notes-cancel-button pt-2 pb-2  ps-2 pe-2 pt-sm-3 pb-sm-3 ps-sm-4 pe-sm-4 width-100' onClick={handleCancelButton}>Cancel</button>
                                        <button className='notes-save-button pt-2 pb-2  ps-2 pe-2 pt-sm-3 pb-sm-3 ps-sm-4 pe-sm-4 width-100' onClick={() => { handleNotesSave() }}>Save</button>
                                    </div>
                                </div>
                                <div className='page-tabs d-flex flex-column flex-sm-row'>
                                    {
                                        historyTabs.map(tab => (
                                            <button
                                                key={tab.value}
                                                type="button"
                                                className={`d-flex align-items-center page-tab${currentTab === tab.value ? ' selected' : ''}`}
                                                onClick={() => { setCurrentTab(tab?.value) }}
                                            >
                                                {tab.label}
                                                {(tab?.value === 'email' || tab?.value === 'all') && allUnreadEmailCount > 0 && (!isLoadingEmailHistories || !isLoadingHistories) && <button className='rounded mx-2 d-flex align-items-center justify-content-center fs-4 text-white' style={{ width: 20, height: 20, backgroundColor: '#ff3333' }} >{allUnreadEmailCount}</button>}
                                            </button>
                                        ))
                                    }
                                </div>
                                <div className='tabs-content mt-4'>
                                    <div className='tab-content' style={{ height: 400, overflowY: 'scroll' }}>
                                        {isLoadingHistories ? <div className='text-center'><Loader /></div> :
                                            (allHistories && currentTab === 'all' && allHistories.length > 0) ? allHistories.map((val, ind) => {
                                                // (allHistoryData && currentTab === 'all' && allHistoryData.length > 0) ? allHistoryData.map((val, ind) => {
                                                return (
                                                    <div key={ind} id={`${val?.callSid}`} className='card d-flex flex-column flex-sm-row border-0'>
                                                        <div>
                                                            <div className='item-image-parent flex align-center justify-center'>
                                                                {(val.hasOwnProperty('isRecorded') && val?.isRecorded) ?
                                                                    <IoRecordingOutline size={26} />
                                                                    : (val.hasOwnProperty('messageId') && val?.messageId) ? <i class="bi bi-envelope fs-1"></i> :
                                                                        <img className='item-image' src={NotesIcon} />
                                                                }
                                                            </div>
                                                            <div className='hor-line d-none d-sm-block'></div>
                                                        </div>
                                                        <div className='left-arrow'>
                                                            <div className='top'></div>
                                                            <div className='bottom'></div>
                                                        </div>
                                                        <Panel
                                                            className={`history-content${val?.messageId ? ' email-history' : ''}`}
                                                            header={panelHeader(val?.hasOwnProperty('isRecorded') ? val?.callStartTime : val?.createdDate ? val?.createdDate : val?.sentDate, val?.userId, val?.hasOwnProperty('isRecorded') ? true : false, val?.callType || '', val?.hasOwnProperty('isRecorded') ? val?.callerAssigned : null, val?.isRecorded, val?.callSid, val?.callDetail?.externalNumber, val?.messageId ? val : null)}
                                                            collapsible
                                                            bordered
                                                            defaultExpanded={val?.hasOwnProperty('isRecorded') ? false : true}
                                                        >
                                                            {
                                                                val?.messageId ? (
                                                                    <EmailHistory
                                                                        parentEmail={val}
                                                                        key={val?.messageId}
                                                                        contacts={contacts}
                                                                        handleReplyEmailClose={handleReplyEmailClose}
                                                                        callerAssignedForEmail={callerAssignedForEmail}
                                                                        setAllUnreadEmailCount={setAllUnreadEmailCount}
                                                                        componentFor='addCallerDetails'
                                                                        vendorId={vendorId}
                                                                    />
                                                                ) : val.hasOwnProperty('isRecorded') ? (
                                                                    <>
                                                                        {!val?.isRecorded && (
                                                                            <h4 className='mb-0 fw-bold text-black'>Call not recorded due to state regulations</h4>
                                                                        )}
                                                                        <AudioTranscript
                                                                            callRecordingSid={(val?.isRecorded && val?.callRecordingSid) ? val?.callRecordingSid : ''}
                                                                            transcriptionSid={val?.callTranscriptionSid}
                                                                            callType={val?.callType}
                                                                            recordingDetails={val}
                                                                            getCallRecordingsHandler={getCallRecordingsHandler}
                                                                            setHistories={setHistories}
                                                                            id={val?.id}
                                                                        />
                                                                    </>
                                                                ) :
                                                                    <div className='note-content h5'
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: val.note
                                                                        }}
                                                                    />
                                                            }
                                                        </Panel>
                                                    </div>
                                                )
                                            })
                                                : currentTab === 'all' && <div className='d-flex justify-content-center'><p>No Data</p></div>
                                        }
                                        {isLoadingEmailHistories ? <div className='text-center'><Loader /></div> :
                                            currentTab === 'email' && parentEmailHistories?.length > 0 ? parentEmailHistories.sort((a, b) => new Date(b?.sentDate) - new Date(a?.sentDate))?.map((emailHistory) => {
                                                return (
                                                    <div key={emailHistory?.messageId} id={`${emailHistory?.messageId}`} className='card d-flex flex-column flex-sm-row border-0'>
                                                        <div className=''>
                                                            <div className='item-image-parent flex align-center justify-center'>
                                                                {(emailHistory?.hasOwnProperty('messageId') && emailHistory?.messageId) && <i class="bi bi-envelope fs-1"></i>}
                                                            </div>
                                                            <div className='hor-line d-none d-sm-block'></div>
                                                        </div>
                                                        <div className='left-arrow'>
                                                            <div className='top'></div>
                                                            <div className='bottom'></div>
                                                        </div>
                                                        <Panel className="history-content border" >
                                                            {emailHistory?.hasOwnProperty('messageId') ? (
                                                                <EmailHistory
                                                                    parentEmail={emailHistory}
                                                                    key={emailHistory?.messageId}
                                                                    contacts={contacts}
                                                                    handleReplyEmailClose={handleReplyEmailClose}
                                                                    callerAssignedForEmail={callerAssignedForEmail}
                                                                    setAllUnreadEmailCount={setAllUnreadEmailCount}
                                                                    componentFor='addCallerDetails'
                                                                    vendorId={vendorId}
                                                                />
                                                            ) :
                                                                <div></div>
                                                            }
                                                        </Panel>
                                                    </div>
                                                )
                                            }) : currentTab === 'email' && <div className='d-flex justify-content-center'><p>No Emails Exchanged</p></div>
                                        }
                                        {currentTab === 'notes' && (
                                            <div className='tab-content'>
                                                {notes && notes.length > 0 ? (
                                                    notes.map((val) => (
                                                        <div key={val.id} className="card d-flex flex-column flex-sm-row border-0">
                                                            <div>
                                                                <div className="item-image-parent flex align-center justify-center">
                                                                    <img className="item-image" src={NotesIcon} alt="Notes Icon" />
                                                                </div>
                                                                <div className="hor-line d-none d-sm-block"></div>
                                                            </div>
                                                            <div className="left-arrow">
                                                                <div className="top"></div>
                                                                <div className="bottom"></div>
                                                            </div>
                                                            <Panel
                                                                className="history-content"
                                                                header={panelHeader(val.createdDate, val.userId)}
                                                                collapsible
                                                                bordered
                                                                defaultExpanded
                                                            >
                                                                <div
                                                                    className="note-content h5"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: val.note,
                                                                    }}
                                                                />
                                                            </Panel>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <h4 className="no_data mb-0 ps-3 text-black fw-bold">No data found.</h4>
                                                )}
                                            </div>
                                        )}
                                        {currentTab === 'files' && (
                                            <div className='tab-content'>
                                                {currentTab === 'files' && (
                                                    <div className="tab-content">
                                                        {files && files.length > 0 ? (
                                                            files.map((val) => (
                                                                <div key={val.id} className="card d-flex flex-column flex-sm-row border-0">
                                                                    <div>
                                                                        <div className="item-image-parent flex align-center justify-center">
                                                                            <AiOutlineFileImage className="item-image" size={20} />
                                                                        </div>
                                                                        <div className="hor-line d-none d-sm-block"></div>
                                                                    </div>
                                                                    <div className="left-arrow">
                                                                        <div className="top"></div>
                                                                        <div className="bottom"></div>
                                                                    </div>
                                                                    <Panel
                                                                        className="history-content"
                                                                        header={panelHeader(val.createdDate)}
                                                                        collapsible
                                                                        bordered
                                                                        defaultExpanded
                                                                    >
                                                                        <div className="note-content h5">
                                                                            <h4>
                                                                                <b>
                                                                                    <em>{val.fileType}</em>
                                                                                </b>
                                                                            </h4>
                                                                            <div className="flex" style={{ marginTop: '10px' }}>
                                                                                <b>{val.note}</b>
                                                                                <FaDownload
                                                                                    className="download-file"
                                                                                    color="#65B3E9"
                                                                                    size={20}
                                                                                    data-filename={val.note}
                                                                                    onClick={(event) => DownloadFile(event)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Panel>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <h4 className="no_data mb-0 ps-3 text-black fw-bold">No data found.</h4>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {currentTab === 'changelog' && (
                                            <div className='tab-content'>
                                                {changeLog && changeLog.length > 0 ? (
                                                    changeLog.map((val, ind) => (
                                                        <div key={val.id || ind} className="card d-flex flex-column flex-sm-row border-0">
                                                            <div>
                                                                <div className="item-image-parent flex align-center justify-center">
                                                                    <img className="item-image" src={ChangeLogIcon} alt="Change Log Icon" />
                                                                </div>
                                                                <div className="hor-line d-none d-sm-block"></div>
                                                            </div>
                                                            <div className="left-arrow">
                                                                <div className="top"></div>
                                                                <div className="bottom"></div>
                                                            </div>
                                                            <Panel
                                                                className="history-content"
                                                                header={panelHeader(val.createdDate, val.userId)}
                                                                collapsible
                                                                bordered
                                                                defaultExpanded
                                                            >
                                                                <div
                                                                    className="note-content h5"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: val.note,
                                                                    }}
                                                                />
                                                            </Panel>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <h4 className="no_data mb-0 ps-3 text-black fw-bold">No data found.</h4>
                                                )}
                                            </div>
                                        )}
                                        {histories &&
                                            currentTab === 'callRecordings' &&
                                            histories.length > 0 &&
                                            histories
                                                .filter((val) => val.hasOwnProperty('isRecorded'))
                                                .map((val) => {
                                                    return (
                                                        <div
                                                            key={val.callSid || val.id}
                                                            id={`${val?.callSid}`}
                                                            className="card d-flex flex-column flex-sm-row border-0"
                                                        >
                                                            <div>
                                                                <div className="item-image-parent flex align-center justify-center">
                                                                    <IoRecordingOutline size={26} />
                                                                </div>
                                                                <div className="hor-line d-none d-sm-block"></div>
                                                            </div>
                                                            <div className="left-arrow">
                                                                <div className="top"></div>
                                                                <div className="bottom"></div>
                                                            </div>
                                                            <Panel
                                                                className="history-content"
                                                                header={panelHeader(
                                                                    val.callStartTime,
                                                                    val.userId,
                                                                    true,
                                                                    val.callType || '',
                                                                    val.callerAssigned,
                                                                    val.isRecorded,
                                                                    val.callSid,
                                                                    val.callDetail?.externalNumber
                                                                )}
                                                                collapsible
                                                                bordered
                                                                defaultExpanded={false}
                                                            >
                                                                {!val?.isRecorded ? (
                                                                    <h4 className="mb-0 fw-bold text-black">
                                                                        Call not recorded due to state regulations
                                                                    </h4>
                                                                ) : (
                                                                    <AudioTranscript
                                                                        callRecordingSid={
                                                                            val?.isRecorded && val?.callRecordingSid
                                                                                ? val?.callRecordingSid
                                                                                : ''
                                                                        }
                                                                        transcriptionSid={val?.callTranscriptionSid}
                                                                        callType={val?.callType}
                                                                        recordingDetails={val}
                                                                        getCallRecordingsHandler={getCallRecordingsHandler}
                                                                        setHistories={setHistories}
                                                                        id={val?.id}
                                                                    />
                                                                )}
                                                            </Panel>
                                                        </div>
                                                    )
                                                }
                                                )}
                                    </div>
                                </div>
                            </div>}
                            {activeTab === 'emails' && (
                                <ComposeEmail
                                    componentFor={'addCallerDetails'}
                                    supplierInfo={supplierInfo}
                                    vendorInfo={vendorInfo}
                                    contactOptions={contactOptions}
                                    onGetExistingContacts={onGetExistingContacts}
                                    vendorInCallDetailsId={vendorInCallDetailsId}
                                    contacts={contacts}
                                    getContactsData={getContactsData}
                                    activeTab={activeTab}
                                    setCurrentTab={setCurrentTab}
                                    actionOnEmail={''}
                                    vendorId={vendorId}
                                />)}
                            {type === 'call' && (
                                <div className={`${user?.isCaller && user?.assignedPhoneNumber ? '' : 'd-none'} dialer-component-parent`}>
                                    {isIncomingCall ? (
                                        <InBoundCallComponent
                                            show={false}
                                            call={call}
                                            phoneNo={incomingPhoneNo}
                                            onCallReject={rejectIncomingCall}
                                            onCallHangup={hangupIncomingCall}
                                            matchData={matchData}
                                            callerSID={callerId}
                                            vendorId={vendorId}
                                        />
                                    ) :
                                        (user?.isCaller && user?.assignedPhoneNumber && !vendorInfo?.isPausedSequencing && vendorInfo?.vendorsInCall?.status !== STOPPED) && (
                                            <DialerComponent
                                                vendorData={vendorInfo}
                                                onCallStartClick={makeOutgoingCall}
                                                onCallEndClick={handleCallEndClick}
                                                callerSID={callSID}
                                                status={status}
                                                isCallDial={isCallDialed}
                                                dialerClass={dialerShowClass}
                                                call={call}
                                                callStartTime={callStartTime}
                                                callsTableData={callsTableData}
                                                vendorId={vendorId}
                                                supPhoneNumber={supPhoneNumber}
                                                removeSupPhoneNumber={handleRemoveSupPhoneNumber}
                                            />
                                        )
                                    }
                                </div>
                            )}
                        </div>
                    </div>

                    {
                        (type === "call" || type === "qa") ?
                            <div className='calling-script border rounded mt-5 bg-white'>
                                <div className='header d-flex align-items-center p-4 border border-top-0 border-end-0 border-start-0'>
                                    <h3 className='mb-0 text-blue fw-bold'>Calling Script</h3>
                                </div>
                                <div className='content d-flex gap-4 p-4 flex-column'>
                                    <div
                                        className='p-4 w-100 h4 mb-0 rounded border'
                                        style={{ maxHeight: "200px", overflow: "auto", }}
                                        dangerouslySetInnerHTML={{
                                            __html: callingScript ? callingScript : "No script found"
                                        }}
                                    />
                                </div>
                            </div>
                            : <></>
                    }
                    <div className={`mt-5 border rounded p-4 pb-5 align-items-center${isLoadingListSupInfo ? ' position-relative loading' : ''}`}>
                        {isLoadingListSupInfo && <LoaderComponent />}
                        <div className='row g-0 mt-5 border rounded p-4 align-items-center'>
                            {type !== 'edit' && (
                                <div className={`${type === 'call' ? 'col-2' : 'col-4'}`}>
                                    <h1 className='text-blue'>{vendorInfo.suppliername || 'Unknown'}</h1>
                                </div>
                            )}
                            {type === 'call' && !vendorInCallsDetails?.isLinkedLater ?
                                <>
                                    <div className='col-7 d-flex flex-column ps-3 pe-3'>
                                        <div className='row g-0 d-flex align-items-center'>
                                            <div className='col-12 row'>
                                                <div className='d-flex align-items-centerd gap-2 col-6'>
                                                    <label className='h4 mb-0 text-black col-4 mt-4'>Partner</label>
                                                    <input
                                                        className='search-input'
                                                        name="partner_name"
                                                        value={(vendorId || vendorInCallsDetailsId) ? vendorInCallsData?.partnerName : ''}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className='d-flex align-items-centerv gap-2 col-6'>
                                                    <label className='h4 mb-0 text-black col-4 mt-4'>Contact Name</label>
                                                    <div className='d-flex flex-column gap-2'>
                                                        <div className="phone-input-parent flex align-center position-relative input-group">
                                                            {contactNameId && (
                                                                <span role='button' class='border-end-0 input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact() }} style={{ height: '48px' }}>X</span>
                                                            )}
                                                            <input
                                                                className='search-input text-primary'
                                                                style={{ marginLeft: contactNameId ? '-10px' : '0' }}
                                                                value={contactName}
                                                                onChange={(e) => { setContactName(e.target.value) }}
                                                                disabled={isUpdatingContactName || isRefusedToProvideName}
                                                                onClick={() => { onContactNameClick() }}
                                                                onMouseOver={(e) => { onContactMouseHover(e) }}
                                                                onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                                data-contact-id={contactNameId || ''}
                                                                autoComplete='no-contact'
                                                            />
                                                            {contactName && contactNameId && !showAllContacts && (
                                                                <ContactView contact={currentContact} />
                                                            )}
                                                            {showAllContacts && (
                                                                <AllContacts contacts={existedContacts} onClose={onContactNameFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} supplierId={supplierInfo?.id} />
                                                            )}

                                                            {isUpdatingContactName && (<Loader />)}
                                                        </div>
                                                        <CheckboxComponent
                                                            label='Supplier refused to provide name'
                                                            checked={isRefusedToProvideName || false}
                                                            onChange={(checked) => { onRefusedToProvideNameChange(checked) }}
                                                            disabled={contactName && contactNameId}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mt-4 col-12 row'>
                                                <div className='d-flex align-items-center gap-2 col-6'>
                                                    <label className='h4 mb-0 text-black col-4'>Customer</label>
                                                    <input
                                                        className='search-input'
                                                        name="customer_name"
                                                        value={(vendorId || vendorInCallsDetailsId) ? vendorInCallsData?.companyName : ''}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className='d-flex align-items-center gap-2 col-6'>
                                                    <label className='h4 mb-0 text-black col-4'>Calls Attempted</label>
                                                    <div className='w-100'>
                                                        <input
                                                            className='search-input me-auto w-25 text-center'
                                                            disabled={true}
                                                            value={vendorInCallData?.callsAttempted || 0}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mt-4 col-12 row'>
                                                <div className='d-flex align-items-center gap-2 col-6'>
                                                    <label className='h4 mb-0 text-black col-4'>Name Use</label>
                                                    <ThreeStateToggleButton checked={(vendorId || vendorInCallsDetailsId) ? vendorInCallsData?.nameUse : null} isDisabled={true} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-3 align-self-start'>
                                        <div className='d-flex flex-column gap-3'>
                                            <h4 className='mb-0 text-black'>Unsuccessful Enablement Reason</h4>
                                            <div className='d-flex flex-row gap-3 align-items-center'>
                                                <Select
                                                    className="h4 mb-0 text-black flex-grow-1 unsucessful-reason-selector"
                                                    placeholder='Select Reason...'
                                                    options={unSuccessfullEnablementReasons.map(option => {
                                                        return {
                                                            label: option,
                                                            value: option
                                                        }
                                                    })}
                                                    value={unSuccessfullEnablementReason}
                                                    onChange={(item) => { setUnSuccessfullEnablementReasons(item) }}
                                                />
                                                <button className='h4 mb-0 rounded width-100 bg-gray text-white pt-3 pb-3' onClick={() => {
                                                    onSubmitClick()
                                                }}>Submit</button>
                                            </div>
                                            <CheckboxComponent
                                                label="Mark as Complete"
                                                checked={false}
                                                onChange={(checked) => { setIsMarkAsComplete(checked) }}
                                            />
                                        </div>
                                    </div>
                                </>
                                :

                                type === 'call' && vendorInCallsDetails?.isLinkedLater ? (
                                    <div className='d-flex  mt-3'>
                                        <div className='col-4'>
                                            <label className='h4 mb-0 text-black col-3'>Contact Name</label>
                                            <div className="phone-input-parent flex align-center position-relative input-group">
                                                {contactNameId && (
                                                    <span role='button' class='border-end-0 input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact() }} style={{ height: '48px' }}>X</span>
                                                )}
                                                <input
                                                    className='search-input text-primary'
                                                    style={{ marginLeft: contactNameId ? '-10px' : '0' }}
                                                    value={contactName}
                                                    onChange={(e) => { setContactName(e.target.value) }}
                                                    disabled={isUpdatingContactName || isRefusedToProvideName}
                                                    onClick={() => { onContactNameClick() }}
                                                    onMouseOver={(e) => { onContactMouseHover(e) }}
                                                    onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                    data-contact-id={contactNameId || ''}
                                                    autoComplete='no-contact'
                                                />
                                                {contactName && contactNameId && !showAllContacts && (
                                                    <ContactView contact={currentContact} />
                                                )}
                                                {showAllContacts && (
                                                    <AllContacts contacts={existedContacts} onClose={onContactNameFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} supplierId={supplierInfo?.id} />
                                                )}
                                                {isUpdatingContactName && (<Loader />)}
                                            </div>
                                        </div>
                                        <div className='col-4 d-flex align-items-center justify-content-center'>
                                            <CheckboxComponent
                                                label='Supplier refused to provide name'
                                                checked={isRefusedToProvideName || false}
                                                onChange={(checked) => { onRefusedToProvideNameChange(checked) }}
                                                disabled={contactName && contactNameId}
                                            />
                                        </div>
                                        <div className='col-4'>
                                            <label className='h4 mb-0 text-black col-3'>Calls Attempted</label>
                                            <input
                                                className='search-input me-auto w-25 text-center'
                                                value={vendorInCallData?.callsAttempted || 0}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                ) : type === 'edit' ?
                                    <div className='d-flex gap-5'>
                                        <div className='d-flex align-items-center gap-2 col-6'>
                                            <label className='h4 mb-0 text-black col-3'>Contact Name</label>
                                            <input
                                                className='search-input w-75'
                                                value={''}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className='d-flex align-items-center gap-2 col-6'>
                                            <label className='h4 mb-0 text-black col-3'>Calls Attempted</label>
                                            <div className='w-100'>
                                                <input
                                                    className='search-input me-auto w-25 text-center'
                                                    value={vendorInCallData?.callsAttempted || 0}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className='d-flex justify-content-end'>
                                        <button className='pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100' onClick={() => { handleRejectClick() }}>Reject</button>
                                        <button className='pt-2 pb-2 h4 ms-3 mb-0 fw-bold rounded btn-green text-white width-100' onClick={() => { handleApproveClick() }}>Approve</button>
                                    </div>
                            }
                        </div>
                        <div className={`supplier-info-parent position-relative${isLoadingAllListSupInfo ? ' loading' : ''}`}>
                            {isLoadingAllListSupInfo && (
                                <LoaderComponent />
                            )}
                            {
                                matchedSupplierId || activeKey === 'reenablement' ? (
                                    <CreateMasterSupplierComponent
                                        listSupplierId={vendorId}
                                        existingSupplierInfo={supplierInfo}
                                        listSupplierInfo={vendorInfo}
                                        supplierBasicInfo={matchedSupplierDetailInfo}
                                        supplierCardAccInfo={supplierCardInfo} //supplierCardInfo
                                        supplierPaymentInfo={supplierPaymentInfo}
                                        onBasicInfoSave={handleNewMasterDetailsSave}
                                        onCardInfoSave={handleNewMatchedCardAccDataSave}
                                        onCheckInfoSave={handleCheckMasterDataSave}
                                        onAchInfoSave={handleACHMasterDataSave}
                                        isLoadingBasicInfo={isLoading?.basicInfo}
                                        isLoadingCardInfo={isLoading?.cardInfo}
                                        isLoadingCheckInfo={isLoading?.checkInfo}
                                        isLoadingAchInfo={isLoading?.achInfo}
                                        onComplete={handleOnComplete}
                                        showComplete={((type === 'qa') || (location?.pathname.includes('editcallerdetails')) || (location?.state?.IsIncomingCall && vendorInCallsDetails?.isLinkedLater)) ? false : true}
                                        onGlobalAccSave={handleGlobalAcceptanceSave}
                                        showAdvancedSettings={showAdvanceSettings}
                                        isUpdatingAdvanceSettings={isLoading?.globalAcc}
                                        onShowHideAdvancedSettings={(value) => setShowAdvanceSettings(value)}
                                        supNameForEIN={supNameForEIN}
                                        isLoading={isLoadingAllListSupInfo}
                                        isDisabledButtons={isDisabledButtons}
                                        onBasicPhoneClick={handleBasicPhoneClick}
                                        onGetChildrenData={handleOnGetChildrenData}
                                        onAssignMaster={handleAssignMaster}
                                        contacts={contacts}
                                        onGetContactsData={getContactsData}
                                        vendorInCallsDetailsId={vendorInCallDetailsId}
                                        matchedSupplierId={matchedSupplierId}
                                        newMasterSupplierBasicInfo={newMasterSupplierBasicInfo} // newMasterSupplierBasicInfo
                                        onBasicInfoCreate={handleBasicInfoCreate}
                                        activeKey={activeKey}
                                    />
                                ) : (
                                    <CreateSupplierComponent
                                        listSupplierId={vendorId}
                                        listSupplierInfo={vendorInfo}
                                        supplierBasicInfo={supplierInfo}
                                        supplierCardAccInfo={supplierCardInfo}
                                        supplierPaymentInfo={supplierPaymentInfo}
                                        onBasicInfoSave={handleBasicDetailsSave}
                                        onCardInfoSave={handleCardAccDataSave}
                                        onCheckInfoSave={handleCheckDataSave}
                                        onAchInfoSave={handleACHDataSave}
                                        isLoadingBasicInfo={isLoading?.basicInfo}
                                        isLoadingCardInfo={isLoading?.cardInfo}
                                        isLoadingCheckInfo={isLoading?.checkInfo}
                                        isLoadingAchInfo={isLoading?.achInfo}
                                        onComplete={handleOnComplete}
                                        showComplete={((type === 'qa') || (location?.pathname.includes('editcallerdetails')) || (location?.state?.IsIncomingCall && vendorInCallsDetails?.isLinkedLater)) ? false : true}
                                        onGlobalAccSave={handleGlobalAcceptanceSave}
                                        showAdvancedSettings={showAdvanceSettings}
                                        isUpdatingAdvanceSettings={isLoading?.globalAcc}
                                        onShowHideAdvancedSettings={(value) => { setShowAdvanceSettings(value) }}
                                        supNameForEIN={supNameForEIN}
                                        isLoading={isLoadingAllListSupInfo}
                                        isDisabledButtons={isDisabledButtons}
                                        onBasicPhoneClick={handleBasicPhoneClick}
                                        onGetChildrenData={handleOnGetChildrenData}
                                        onAssignMaster={handleAssignMaster}
                                        contacts={contacts}
                                        onGetContactsData={getContactsData}
                                        vendorInCallsDetailsId={vendorInCallDetailsId}
                                    />
                                )}
                        </div>


                        {type === 'qa' && (
                            <div className='float-end position-sticky bottom-0'>
                                <button className='pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100' onClick={() => { handleRejectClick() }}>Reject</button>
                                <button className='pt-2 pb-2 h4 ms-3 mb-0 fw-bold rounded btn-green text-white width-100' onClick={() => { handleApproveClick() }}>Approve</button>
                            </div>
                        )}
                    </div>

                    <div className='child-suupliers-table-parent mt-4'>
                        <Panel header={PanelHeader('Child Suppliers')} className={`supply-card-acceptance bg-white mt-0`} defaultExpanded={false} collapsible bordered>
                            <div className="supply-acceptance flex-column flex-xl-row flex-nowrap flex-md-wrap">
                                <div className="col me-0 me-xl-3">
                                    <ChildSuppliers
                                        tableData={childSuppliers}
                                    />
                                </div>
                            </div>
                        </Panel>
                    </div>
                    <div className='child-suupliers-table-parent mt-4'>
                        <SupplierHistoricalPayments
                            masterId={matchedSupplierId}
                        />
                    </div>
                    <QaNotesModal
                        show={showQaPromt}
                        onClose={() => setShowQaPromt(false)}
                        onDone={handleSubmitQA}
                    />
                    <QaNotesModal
                        show={showShareCall}
                        onClose={() => { setShowShareCall(false) }}
                        onDone={handleShareCallSubmit}
                        title='Share Call'
                        size='md'
                        isShareCallModal={true}
                    />
                    {
                        showStopModal && (
                            <Modal
                                backdrop={'static'}
                                className="link-to-vendor-modal"
                                show={showStopModal}
                                size="lg"
                                onHide={() => { setShowStopModal(false) }}
                            >
                                <Modal.Header>
                                    <Modal.Title className='text-black fw-bold text-wrap'>
                                        This supplier has been stopped. If you reject QA, all card acceptance that has been gathered in this sequence will be removed. Are you sure you want to reject?                                </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className='mt-4 h-75'>

                                </Modal.Body>
                                <Modal.Footer>
                                    <button
                                        type="button"
                                        className="me-3 h4 mb-0 pt-2 pb-2 bg-gray text-white width-100 rounded"
                                        onClick={() => { setShowStopModal(false) }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="h4 mb-0 pt-2 pb-2 btn-green width-100 rounded"
                                        onClick={() => { handleSubmitQA() }}
                                    >
                                        Confirm
                                    </button>
                                </Modal.Footer>
                            </Modal>
                        )
                    }
                </div>
                {showCreateChild && (
                    <>
                        <ModalComponent size='xl' modalTitle='Create Child' open={showCreateChild} handleClose={handleClose} dialogClassName='create-child-modal-dialog'
                        >
                            <CreateChildVendorFromMaster
                                masterSupplierData={supplierInfo}
                                onClose={handleClose}
                                isFromCalls={true}
                                listSupplierId={matchedSupplierId || activeKey === 'reenablement' ? newMasterSupplierBasicInfo?.baseInfo?.id : vendorId}
                                vendorInCallDetailsId={vendorInCallDetailsId}
                                contacts={contacts || []}
                                isMasterType={matchedSupplierId || activeKey === 'reenablement' ? true : false}
                            />
                        </ModalComponent>
                    </>
                )}
                {showAddNewContact && (
                    <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <CreateContact
                            onClose={handleCreateContactClose}
                            contactDataFromField={contactDataFromField}
                            supplierId={supplierInfo?.id || null}
                            listSupplierId={supplierInfo?.id ? null : vendorInfo?.id}
                            isInCalls={supplierInfo?.id ? null : true}
                            vendorInCallsDetailsId={supplierInfo?.id ? null : (vendorInCallDetailsId || null)}
                        />
                    </ModalComponent>
                )}
            </Beforeunload>
        </>
    )
}

export default AddCallerDetails